<template>
  <div>
    <div class="ui secondary three item menu">
      <a class="item"
         @click="getRPGs(year-2)"
      >
        Рабочие программы {{ year-2 }} года
      </a>
      <a class="item"
         @click="getRPGs(year-1)"
      >
        Рабочие программы {{ year-1 }} года
      </a>
      <a class="active item"
         @click="getRPGs(year)"
      >
        Рабочие программы {{ year }} года
      </a>
    </div>
    <h4 class="ui horizontal divider header" >
      <i class="copy outline icon"></i>
      Шаблоны
    </h4>
    <div class="ui styled fluid accordion" >
      <div v-for="prog in samples">
        <div class="title">
          <tr>
            <td width="5%">
              {{ prog.id }}
            </td>
            <td width="1%">
              <i class="dropdown icon"></i>
            </td>
            <td width="30%">
              {{ prog.name }}
            </td>
            <td width="30%">
              {{ prog.main_info.speciality }}
            </td>
            <td width="15%">
              {{ prog.main_info.profile }}
            </td>
            <td width="5%">
              {{ prog.main_info.year }}
            </td>
            <td width="14%">
              <i v-if="prog.library_agreed === true" class="check big square icon" style="color: green"></i>
              <i v-else-if="prog.library_agreed === false" class="times big square icon" style="color: red"></i>
              <i v-else class="minus square big icon" style="color: grey"></i>
              <i v-if="prog.software_agreed === true" class="check big square icon" style="color: green"></i>
              <i v-else-if="prog.software_agreed === false" class="times big square icon"style="color: red"></i>
              <i v-else class="minus big square icon" style="color: grey"></i>
              <i v-if="prog.department_agreed === true" class="check big square icon" style="color: green"></i>
              <i v-else-if="prog.department_agreed === false" class="times big square icon" style="color: red"></i>
              <i v-else class="minus big square icon" style="color: grey"></i>
            </td>
          </tr>
        </div>
        <div class="content">
          <div class="ui fitted divider"></div>
          <div class="inline fields">
            <div class="ui fitted toggle checkbox">
              <input @change="useSample(prog.id, prog.rpg_sample)" type="checkbox" name="example" v-model="prog.rpg_sample">
              <label></label>
            </div>
            <div class="ui large blue label">Использовать в качестве шаблона</div>
          </div>
        </div>
      </div>
    </div>
    <h4 class="ui horizontal divider header" >
      <i class="times icon"></i>
      Отклонено
    </h4>
    <div class="ui styled fluid accordion" style="color: red">
      <div v-for="prog in decline">
        <div class="title">
          <tr style="color: red">
            <td width="5%">
              {{ prog.id }}
            </td>
            <td width="1%">
              <i class="dropdown icon"></i>
            </td>
            <td width="30%">
              {{ prog.name }}
            </td>
            <td width="30%">
              {{ prog.main_info.speciality }}
            </td>
            <td width="15%">
              {{ prog.main_info.profile }}
            </td>
            <td width="5%">
              {{ prog.main_info.year }}
            </td>
            <td width="14%">
              <i v-if="prog.library_agreed === true" class="check big square icon" style="color: green"></i>
              <i v-else-if="prog.library_agreed === false" class="times big square icon" style="color: red"></i>
              <i v-else class="minus square big icon" style="color: grey"></i>
              <i v-if="prog.software_agreed === true" class="check big square icon" style="color: green"></i>
              <i v-else-if="prog.software_agreed === false" class="times big square icon"style="color: red"></i>
              <i v-else class="minus big square icon" style="color: grey"></i>
              <i v-if="prog.department_agreed === true" class="check big square icon" style="color: green"></i>
              <i v-else-if="prog.department_agreed === false" class="times big square icon" style="color: red"></i>
              <i v-else class="minus big square icon" style="color: grey"></i>
              <i v-if="prog.umu_agreed === true && prog.main_info.doc_type === 'ПРОГРАММА НАУЧНЫХ ИССЛЕДОВАНИЙ'" class="check big square icon" style="color: green"></i>
              <i v-else-if="prog.umu_agreed === false && prog.main_info.doc_type === 'ПРОГРАММА НАУЧНЫХ ИССЛЕДОВАНИЙ'" class="times big square icon" style="color: red"></i>
              <i v-else-if="prog.umu_agreed === null && prog.main_info.doc_type === 'ПРОГРАММА НАУЧНЫХ ИССЛЕДОВАНИЙ'" class="minus big square icon" style="color: grey"></i>
            </td>
          </tr>
        </div>
        <div class="content">
          <tr>
            <td width="15%"><h4>Отправленно на согласование</h4></td>
            <td width="9%" style="color: black">{{new Date(prog.updated_at).toISOString().slice(0, 10)}}</td>
            <td width="19%">
              <h4>
                Согласованно Библиотекой
                <i v-if="prog.library_agreed === true" class="check square icon" style="color: green"></i>
                <i v-else-if="prog.library_agreed === false" class="times square icon" style="color: red"></i>
                <i v-else class="minus square icon" style="color: grey"></i>
              </h4>
            </td>
            <td width="19%">
              <h4>
                Согласованно ЦЦТиТО
                <i v-if="prog.software_agreed === true" class="check square icon" style="color: green"></i>
                <i v-else-if="prog.software_agreed === false" class="times square icon"style="color: red"></i>
                <i v-else class="minus square icon" style="color: grey"></i>
              </h4>
            </td>
            <td width="19%">
              <h4>
                Согласованно Вып.Кафедрой
                <i v-if="prog.department_agreed === true" class="check square icon" style="color: green"></i>
                <i v-else-if="prog.department_agreed === false" class="times square icon" style="color: red"></i>
                <i v-else class="minus square icon" style="color: grey"></i>
              </h4>
            </td>
            <td width="19%" v-if="prog.main_info.doc_type === 'ПРОГРАММА НАУЧНЫХ ИССЛЕДОВАНИЙ'">
              <h4>
                Согласованно УМУ
                <i v-if="prog.umu_agreed === true" class="check square icon" style="color: green"></i>
                <i v-else-if="prog.umu_agreed === false" class="times square icon" style="color: red"></i>
                <i v-else class="minus square icon" style="color: grey"></i>
              </h4>
            </td>
          </tr>
          <tr>
            <td width="15%"></td>
            <td width="9%"></td>
            <td width="19%">
              <h4>Комментарий</h4>
              {{prog.library_comment}}
            </td>
            <td width="19%" style="color: black">
              <h4>Комментарий</h4>
              {{prog.software_comment}}
            </td>
            <td width="19%">
              <h4>Комментарий</h4>
              {{prog.department_comment}}
            </td>
            <td v-if="prog.main_info.doc_type === 'ПРОГРАММА НАУЧНЫХ ИССЛЕДОВАНИЙ'" width="19%" style="color: black">
              <h4>Комментарий</h4>
              {{prog.umu_comment}}
            </td>
          </tr>
          <div class="ui fitted divider"></div>
          <div class="inline fields">
            <div class="ui fitted toggle checkbox">
              <input @change="useSample(prog.id, prog.rpg_sample)" type="checkbox" name="example" v-model="prog.rpg_sample">
              <label></label>
            </div>
            <div class="ui large blue label">Использовать в качестве шаблона</div>
          </div>
          <div class="ui fitted divider"></div>
          <div>
            <button class="ui button positive" v-on:click="editRPG(prog.id)">
              <i class="edit icon"></i>
              Редактировать рабочую программу
            </button>
            <button class="ui right floated button red" v-on:click="deleteRPD(prog.id)">
              <i class="trash icon"></i>
              Удалить рабочую программу
            </button>
          </div>
        </div>
      </div>
    </div>
    <h4 class="ui horizontal divider header" >
      <i class="archive icon"></i>
      Готовы
    </h4>
    <div class="ui styled fluid accordion" >
      <div v-for="prog in ready">
        <div class="title">
          <tr>
            <td width="5%">
              {{ prog.id }}
            </td>
            <td width="1%">
              <i class="dropdown icon"></i>
            </td>
            <td width="30%">
              {{ prog.name }}
            </td>
            <td width="30%">
              {{ prog.main_info.speciality }}
            </td>
            <td width="15%">
              {{ prog.main_info.profile }}
            </td>
            <td width="5%">
              {{ prog.main_info.year }}
            </td>
            <td width="14%">
              <i v-if="prog.library_agreed === true" class="check big square icon" style="color: green"></i>
              <i v-else-if="prog.library_agreed === false" class="times big square icon" style="color: red"></i>
              <i v-else class="minus square big icon" style="color: grey"></i>
              <i v-if="prog.software_agreed === true" class="check big square icon" style="color: green"></i>
              <i v-else-if="prog.software_agreed === false" class="times big square icon"style="color: red"></i>
              <i v-else class="minus big square icon" style="color: grey"></i>
              <i v-if="prog.department_agreed === true" class="check big square icon" style="color: green"></i>
              <i v-else-if="prog.department_agreed === false" class="times big square icon" style="color: red"></i>
              <i v-else class="minus big square icon" style="color: grey"></i>
              <i v-if="prog.umu_agreed === true && prog.main_info.doc_type === 'ПРОГРАММА НАУЧНЫХ ИССЛЕДОВАНИЙ'" class="check big square icon" style="color: green"></i>
              <i v-else-if="prog.umu_agreed === false && prog.main_info.doc_type === 'ПРОГРАММА НАУЧНЫХ ИССЛЕДОВАНИЙ'" class="times big square icon" style="color: red"></i>
              <i v-else-if="prog.umu_agreed === null && prog.main_info.doc_type === 'ПРОГРАММА НАУЧНЫХ ИССЛЕДОВАНИЙ'" class="minus big square icon" style="color: grey"></i>
            </td>
          </tr>
        </div>
        <div class="content">
          <tr>
            <td width="15%"><h4>Отправленно на согласование</h4></td>
            <td width="9%" style="color: black">{{new Date(prog.updated_at).toISOString().slice(0, 10)}}</td>
            <td width="19%">
              <h4>
                Согласованно Библиотекой
                <i v-if="prog.library_agreed === true" class="check square icon" style="color: green"></i>
                <i v-else-if="prog.library_agreed === false" class="times square icon" style="color: red"></i>
                <i v-else class="minus square icon" style="color: grey"></i>
              </h4>
            </td>
            <td width="19%">
              <h4>
                Согласованно ЦЦТиТО
                <i v-if="prog.software_agreed === true" class="check square icon" style="color: green"></i>
                <i v-else-if="prog.software_agreed === false" class="times square icon"style="color: red"></i>
                <i v-else class="minus square icon" style="color: grey"></i>
              </h4>
            </td>
            <td width="19%">
              <h4>
                Согласованно Вып.Кафедрой
                <i v-if="prog.department_agreed === true" class="check square icon" style="color: green"></i>
                <i v-else-if="prog.department_agreed === false" class="times square icon" style="color: red"></i>
                <i v-else class="minus square icon" style="color: grey"></i>
              </h4>
            </td>
            <td width="19%" v-if="prog.main_info.doc_type === 'ПРОГРАММА НАУЧНЫХ ИССЛЕДОВАНИЙ'">
              <h4>
                Согласованно УМУ
                <i v-if="prog.umu_agreed === true" class="check square icon" style="color: green"></i>
                <i v-else-if="prog.umu_agreed === false" class="times square icon" style="color: red"></i>
                <i v-else class="minus square icon" style="color: grey"></i>
              </h4>
            </td>
          </tr>
          <tr>
            <td width="15%"></td>
            <td width="9%"></td>
            <td width="19%">
              <h4>Комментарий</h4>
              {{prog.library_comment}}
            </td>
            <td width="19%" style="color: black">
              <h4>Комментарий</h4>
              {{prog.software_comment}}
            </td>
            <td width="19%">
              <h4>Комментарий</h4>
              {{prog.department_comment}}
            </td>
            <td v-if="prog.main_info.doc_type === 'ПРОГРАММА НАУЧНЫХ ИССЛЕДОВАНИЙ'" width="19%" style="color: black">
              <h4>Комментарий</h4>
              {{prog.umu_comment}}
            </td>
          </tr>
          <div class="ui fitted divider"></div>
          <div class="inline fields">
            <div class="ui fitted toggle checkbox">
              <input @change="useSample(prog.id, prog.rpg_sample)" type="checkbox" name="example" v-model="prog.rpg_sample">
              <label></label>
            </div>
            <div class="ui large blue label">Использовать в качестве шаблона</div>
            <div class="ui fitted toggle checkbox">
              <input @change="sendToConsidered(prog.id, prog.considered)" type="checkbox" name="example" v-model="prog.considered">
              <label></label>
            </div>
            <div class="ui large brown label">На рассмотрении</div>
          </div>
          <div class="ui fitted divider"></div>
          <div>
            <button class="ui button positive" v-on:click="editRPG(prog.id)">
              <i class="edit icon"></i>
              Редактировать рабочую программу
            </button>
            <button class="ui right floated button red" v-on:click="deleteRPD(prog.id)">
              <i class="trash icon"></i>
              Удалить рабочую программу
            </button>
          </div>
        </div>
      </div>
    </div>
    <h4 class="ui horizontal divider header" >
      <i class="eye icon"></i>
      На рассмотрении
    </h4>
    <div class="ui styled fluid accordion" >
      <div v-for="prog in consideration">
        <div class="title">
          <tr>
            <td width="5%">
              {{ prog.id }}
            </td>
            <td width="1%">
              <i class="dropdown icon"></i>
            </td>
            <td width="30%">
              {{ prog.name }}
            </td>
            <td width="30%">
              {{ prog.main_info.speciality }}
            </td>
            <td width="15%">
              {{ prog.main_info.profile }}
            </td>
            <td width="5%">
              {{ prog.main_info.year }}
            </td>
            <td width="14%">
              <i v-if="prog.library_agreed === true" class="check big square icon" style="color: green"></i>
              <i v-else-if="prog.library_agreed === false" class="times big square icon" style="color: red"></i>
              <i v-else class="minus square big icon" style="color: grey"></i>
              <i v-if="prog.software_agreed === true" class="check big square icon" style="color: green"></i>
              <i v-else-if="prog.software_agreed === false" class="times big square icon"style="color: red"></i>
              <i v-else class="minus big square icon" style="color: grey"></i>
              <i v-if="prog.department_agreed === true" class="check big square icon" style="color: green"></i>
              <i v-else-if="prog.department_agreed === false" class="times big square icon" style="color: red"></i>
              <i v-else class="minus big square icon" style="color: grey"></i>
              <i v-if="prog.umu_agreed === true && prog.main_info.doc_type === 'ПРОГРАММА НАУЧНЫХ ИССЛЕДОВАНИЙ'" class="check big square icon" style="color: green"></i>
              <i v-else-if="prog.umu_agreed === false && prog.main_info.doc_type === 'ПРОГРАММА НАУЧНЫХ ИССЛЕДОВАНИЙ'" class="times big square icon" style="color: red"></i>
              <i v-else-if="prog.umu_agreed === null && prog.main_info.doc_type === 'ПРОГРАММА НАУЧНЫХ ИССЛЕДОВАНИЙ'" class="minus big square icon" style="color: grey"></i>
            </td>
          </tr>
        </div>
        <div class="content">
          <tr>
            <td width="15%"><h4>Отправленно на согласование</h4></td>
            <td width="9%">{{new Date(prog.updated_at).toISOString().slice(0, 10)}}</td>
            <td width="19%">
              <h4>
                Согласованно Библиотекой
                <i v-if="prog.library_agreed === true" class="check square icon" style="color: green"></i>
                <i v-else-if="prog.library_agreed === false" class="times square icon" style="color: red"></i>
                <i v-else class="minus square icon" style="color: grey"></i>
              </h4>
            </td>
            <td width="19%">
              <h4>
                Согласованно ЦЦТиТО
                <i v-if="prog.software_agreed === true" class="check square icon" style="color: green"></i>
                <i v-else-if="prog.software_agreed === false" class="times square icon"style="color: red"></i>
                <i v-else class="minus square icon" style="color: grey"></i>
              </h4>
            </td>
            <td width="19%">
              <h4>
                Согласованно Вып.Кафедрой
                <i v-if="prog.department_agreed === true" class="check square icon" style="color: green"></i>
                <i v-else-if="prog.department_agreed === false" class="times square icon" style="color: red"></i>
                <i v-else class="minus square icon" style="color: grey"></i>
              </h4>
            </td>
            <td width="19%" v-if="prog.main_info.doc_type === 'ПРОГРАММА НАУЧНЫХ ИССЛЕДОВАНИЙ'">
              <h4>
                Согласованно УМУ
                <i v-if="prog.umu_agreed === true" class="check square icon" style="color: green"></i>
                <i v-else-if="prog.umu_agreed === false" class="times square icon" style="color: red"></i>
                <i v-else class="minus square icon" style="color: grey"></i>
              </h4>
            </td>
          </tr>
          <tr>
            <td width="15%"></td>
            <td width="9%"></td>
            <td width="19%">
              <h4>Комментарий</h4>
              {{prog.library_comment}}
            </td>
            <td width="19%" style="color: black">
              <h4>Комментарий</h4>
              {{prog.software_comment}}
            </td>
            <td width="19%">
              <h4>Комментарий</h4>
              {{prog.department_comment}}
            </td>
            <td v-if="prog.main_info.doc_type === 'ПРОГРАММА НАУЧНЫХ ИССЛЕДОВАНИЙ'" width="19%" style="color: black">
              <h4>Комментарий</h4>
              {{prog.umu_comment}}
            </td>
          </tr>
          <div class="ui fitted divider"></div>
          <div class="inline fields">
            <div class="ui fitted toggle checkbox">
              <input @change="useSample(prog.id, prog.rpg_sample)" type="checkbox" name="example" v-model="prog.rpg_sample">
              <label></label>
            </div>
            <div class="ui large blue label">Использовать в качестве шаблона</div>
            <div class="ui fitted toggle checkbox">
              <input @change="sendToConsidered(prog.id, prog.considered)" type="checkbox" name="example" v-model="prog.considered">
              <label></label>
            </div>
            <div class="ui large brown label">На рассмотрении</div>
          </div>
          <div class="ui fitted divider"></div>
          <div>
            <button class="ui button positive" v-on:click="editRPG(prog.id)">
              <i class="edit icon"></i>
              Редактировать рабочую программу
            </button>
            <button class="ui right floated button red" v-on:click="deleteRPD(prog.id)">
              <i class="trash icon"></i>
              Удалить рабочую программу
            </button>
          </div>
        </div>
      </div>
    </div>
    <h4 class="ui horizontal divider header" >
      <i class="check icon"></i>
      Согласовано
    </h4>
    <div class="ui styled fluid accordion" style="color: green">
      <div v-for="prog in acceptList">
        <div class="title">
          <tr style="color: green">
            <td width="5%">
              {{ prog.id }}
            </td>
            <td width="1%">
              <i class="dropdown icon"></i>
            </td>
            <td width="40%">
              {{ prog.name }}
            </td>
            <td width="30%">
              {{ prog.main_info.speciality }}
            </td>
            <td width="15%">
              {{ prog.main_info.profile }}
            </td>
            <td width="5%">
              {{ prog.main_info.year }}
            </td>
            <td width="14%">
              <i v-if="prog.library_agreed === true" class="check big square icon" style="color: green"></i>
              <i v-else-if="prog.library_agreed === false" class="times big square icon" style="color: red"></i>
              <i v-else class="minus square big icon" style="color: grey"></i>
              <i v-if="prog.software_agreed === true" class="check big square icon" style="color: green"></i>
              <i v-else-if="prog.software_agreed === false" class="times big square icon"style="color: red"></i>
              <i v-else class="minus big square icon" style="color: grey"></i>
              <i v-if="prog.department_agreed === true" class="check big square icon" style="color: green"></i>
              <i v-else-if="prog.department_agreed === false" class="times big square icon" style="color: red"></i>
              <i v-else class="minus big square icon" style="color: grey"></i>
              <i v-if="prog.umu_agreed === true && prog.main_info.doc_type === 'ПРОГРАММА НАУЧНЫХ ИССЛЕДОВАНИЙ'" class="check big square icon" style="color: green"></i>
              <i v-else-if="prog.umu_agreed === false && prog.main_info.doc_type === 'ПРОГРАММА НАУЧНЫХ ИССЛЕДОВАНИЙ'" class="times big square icon" style="color: red"></i>
              <i v-else-if="prog.umu_agreed === null && prog.main_info.doc_type === 'ПРОГРАММА НАУЧНЫХ ИССЛЕДОВАНИЙ'" class="minus big square icon" style="color: grey"></i>
            </td>
          </tr>
        </div>
        <div class="content">
          <tr>
            <td width="15%"><h4>Согласованно</h4></td>
            <td width="9%" style="color: black">{{new Date(prog.updated_at).toISOString().slice(0, 10)}}</td>
            <td width="19%">
              <h4>
                Согласованно Библиотекой
                <i v-if="prog.library_agreed === true" class="check square icon" style="color: green"></i>
                <i v-else-if="prog.library_agreed === false" class="times square icon" style="color: red"></i>
                <i v-else class="minus square icon" style="color: grey"></i>
              </h4>
            </td>
            <td width="19%">
              <h4>
                Согласованно ЦЦТиТО
                <i v-if="prog.software_agreed === true" class="check square icon" style="color: green"></i>
                <i v-else-if="prog.software_agreed === false" class="times square icon"style="color: red"></i>
                <i v-else class="minus square icon" style="color: grey"></i>
              </h4>
            </td>
            <td width="19%">
              <h4>
                Согласованно Вып.Кафедрой
                <i v-if="prog.department_agreed === true" class="check square icon" style="color: green"></i>
                <i v-else-if="prog.department_agreed === false" class="times square icon" style="color: red"></i>
                <i v-else class="minus square icon" style="color: grey"></i>
              </h4>
            </td>
            <td width="19%" v-if="prog.main_info.doc_type === 'ПРОГРАММА НАУЧНЫХ ИССЛЕДОВАНИЙ'">
              <h4>
                Согласованно УМУ
                <i v-if="prog.umu_agreed === true" class="check square icon" style="color: green"></i>
                <i v-else-if="prog.umu_agreed === false" class="times square icon" style="color: red"></i>
                <i v-else class="minus square icon" style="color: grey"></i>
              </h4>
            </td>
          </tr>
          <tr>
            <td width="15%"></td>
            <td width="9%"></td>
            <td width="19%" style="color: black">
              <h4>Комментарий</h4>
              {{prog.library_comment}}
            </td>
            <td width="19%" style="color: black">
              <h4>Комментарий</h4>
              {{prog.software_comment}}
            </td>
            <td width="19%" style="color: black">
              <h4>Комментарий</h4>
              {{prog.department_comment}}
            </td>
            <td v-if="prog.main_info.doc_type === 'ПРОГРАММА НАУЧНЫХ ИССЛЕДОВАНИЙ'" width="19%" style="color: black">
              <h4>Комментарий</h4>
              {{prog.umu_comment}}
            </td>
          </tr>
          <div class="ui fitted divider"></div>
          <div class="inline fields">
            <div class="ui fitted toggle checkbox">
              <input @change="useSample(prog.id, prog.rpg_sample)" type="checkbox" name="example" v-model="prog.rpg_sample">
              <label></label>
            </div>
            <div class="ui large blue label">Использовать в качестве шаблона</div>
          </div>
          <div class="ui fitted divider"></div>
          <div v-if="new Date(prog.created_at).getFullYear() === new Date().getFullYear()">
            <button class="ui button positive" v-on:click="editRPG(prog.id)">
              <i class="edit icon"></i>
              Редактировать рабочую программу(необходимо согласовывать заново)
            </button>
          </div>
          <div class="ui fitted divider"></div>
          <div>
            <button class="ui button blue" v-on:click="showRPG(prog.id)">
              <i class="eye icon"></i>
              Посмотреть
            </button>
            <button v-if="prog.main_info.doc_type === 'ПРОГРАММА ИТОГОВОЙ АТЕСТАЦИИ'" class="ui right floated button brown" v-on:click="MakeIAPDF(prog)">
              <i class="file pdf outline icon"></i>
              Сформировать PDF
            </button>
            <button v-else-if="prog.main_info.doc_type === 'ПРОГРАММА НАУЧНЫХ ИССЛЕДОВАНИЙ'" class="ui right floated button brown" v-on:click="MakeNIPDF(prog)">
              <i class="file pdf outline icon"></i>
              Сформировать PDF
            </button>
            <button v-else class="ui right floated button brown" v-on:click="MakePDF(prog)">
              <i class="file pdf outline icon"></i>
              Сформировать PDF
            </button>
            <button v-if="prog.main_info.doc_type !== 'ПРОГРАММА ИТОГОВОЙ АТЕСТАЦИИ'" class="ui right floated button brown" v-on:click="MakeSupplementPDF(prog)">
              <i class="file pdf outline icon"></i>
              Сформировать лист дополнения
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="ui modal" id="delete_modal">
      <div class="ui header">Удалить рабочую программу дисциплин?</div>
      <div class="content">
        <div class="ui form">
          <div class="field">
            <p>Подтвердите удаление</p>
          </div>
        </div>
      </div>
      <div class="actions">
        <div class="ui negative button">
          Нет
        </div>
        <div class="ui positive right labeled icon button">
          Да
          <i class="checkmark icon"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import htmlToText from "html-to-text";
export default {
  name: "index_rpg",
  data: () => ({
    rpg: [],
    ready: [],
    consideration: [],
    accepting: [],
    decline: [],
    samples: [],
    year: new Date().getFullYear(),
  }),

  computed: {
    acceptList: function () {
      this.consideration = [];
      this.accepting = [];
      this.decline = [];
      this.samples = [];
      this.ready = [];
      this.rpg.forEach(prog => {
        if (prog.rpg_sample === true) {
          this.samples.push(prog);
        }
        if ((prog.library_agreed === true && prog.department_agreed === true && prog.software_agreed === true && prog.main_info.doc_type !== "ПРОГРАММА НАУЧНЫХ ИССЛЕДОВАНИЙ") || (prog.main_info.doc_type === "ПРОГРАММА НАУЧНЫХ ИССЛЕДОВАНИЙ" && prog.umu_agreed === true)){
          this.accepting.push(prog);
        } 
        else if (prog.library_agreed === false || prog.department_agreed === false || prog.software_agreed === false || (prog.main_info.doc_type === "ПРОГРАММА НАУЧНЫХ ИССЛЕДОВАНИЙ" && prog.umu_agreed === false)){
          this.decline.push(prog);
        } 
        else {
          if (prog.considered === false) {
            this.ready.push(prog);
          } else {
            this.consideration.push(prog);
          }
        }
      })
      return this.accepting;
    },
  },
  methods: {
    getRPGs(year) {
      axios({
        method: 'get',
        url: `rpg/year/${year}`
      }).then((response) => {
        this.rpg = response.data.rpg
        this.rpg.sort(function (a, b) {
          return a.id - b.id;
        });
      }).catch((error) => {
        return error;
      });
    },
    editRPG(id) {
      location.assign(`/programms/rpg/${id}/edit`)
    },
    showRPG(id) {
      location.assign(`/programms/rpg/${id}`)
    },
    deleteRPD(id) {
      $('#delete_modal').modal({
        closable: false,
        autofocus: false,
        onDeny: () => {
        },
        onApprove: () => {
          axios({
            method: 'get',
            url: `/programms/destroy_rpg/${id}`
          }).then((response) => {
            this.getRPGs(this.year);
          }).catch((error) => {
            return error;
          });
        }
      }).modal('show');
    },
    useSample(id, rpg_sample) {
      const token = document.querySelector('[name=csrf-token]').content;
      axios.defaults.headers.common['X-CSRF-TOKEN'] = token;
      axios({
        method: 'put',
        url: '/programms/rpg/' + id,
        data: {
          data: {
            rpg_sample: rpg_sample,
          }
        }
      }).then((response) => {

      }).catch((error) => {
        return error;
      });
    },
    sendToConsidered(id, considered) {
      const token = document.querySelector('[name=csrf-token]').content;
      axios.defaults.headers.common['X-CSRF-TOKEN'] = token;
      axios({
        method: 'put',
        url: '/programms/rpg/' + id,
        data: {
          data: {
            considered: considered,
          }
        }
      }).then((response) => {

      }).catch((error) => {
        return error;
      });
    },
    MakePDF(prog){
      pdfMake.fonts = {
        Times: {
          normal: 'TimesNewRomanCyrRegular.TTF',
          bold: 'TimesNewRomanCyrBold.TTF',
          italics: 'TimesNewRomanCyrItalic.TTF',
          bolditalics: 'TimesNewRomanCyrBoldItalic.TTF'
        }
      }
      moment.locale('ru');
      const htmlToText = require('html-to-text');
      let special = ""
      let profile = ""
      let basis_profile = ""
      function getInitial(fio){
        let initial = ""
        if (fio !== ""){
          fio = fio.replaceAll("  ", " ")
          fio = fio.trim();
          initial += fio.split(' ')[1][0];
          initial +="."
          initial += fio.split(' ')[2][0];
          initial +=". "
          initial += fio.split(' ')[0];
        }
        return initial
      }
      let basis_first = ``
      let basis_second = ``
      if (['01.03.02','09.03.01','09.03.02','09.03.04','13.03.01','13.03.02','24.03.01','29.03.05','39.03.01','39.03.02','41.03.01','42.03.01','42.03.02','43.03.02','43.03.03','44.03.01','44.03.02','44.03.05','45.03.03','01.04.02','09.04.04','13.04.02','39.04.02','41.04.01','42.04.01','43.04.02','44.04.01','44.04.02'].includes(prog.main_info.speciality_code)){
        basis_first = `Программа разработана на основании квалификационных требований ФГОС ВО ${prog.main_info.speciality}, утвержденного приказом Министерства образования и науки Российской Федерации от ${prog.main_info.basis_date} № ${prog.main_info.basis_num}`
        basis_second = `Федеральным государственным образовательным стандартом ВО по ${special} ${prog.main_info.speciality}, утвержденным приказом Министерством образования и науки РФ ${prog.main_info.basis_date} № ${prog.main_info.basis_num} предусмотрена государственная итоговая аттестация выпускников в виде:`
      }
      else{
        basis_first = `Программа разработана на основании квалификационных требований ФГОС ВО ${prog.main_info.speciality}, утвержденного приказом Министерства науки и высшего образования Российской Федерации от ${prog.main_info.basis_date} № ${prog.main_info.basis_num}`
        basis_second = `Федеральным государственным образовательным стандартом ВО по ${special} ${prog.main_info.speciality}, утвержденным приказом Министерством науки и высшего образования РФ ${prog.main_info.basis_date} № ${prog.main_info.basis_num} предусмотрена государственная итоговая аттестация выпускников в виде:`
      }
      let department = []
      if (prog.main_info.department !== null){
        department = prog.main_info.department.split(' ').slice(1);
      }
      if (prog.main_info.dep_manager === null){
        prog.main_info.dep_manager = ""
      }
      if (prog.preamble_comp === null){
        prog.preamble_comp = ""
      }
      if (prog.main_info.speciality_code === '38.05.02' || prog.main_info.speciality_code === '37.05.01'){
        special = "специальности"
        profile = "Направленность (профиль) программы специалитета"
      }
      else if (prog.main_info.speciality_code === '38.05.01'){
        special = "специальности"
        profile = "Специализация программы специалитета"
      }
      else if (prog.main_info.speciality_code.split('.')[1] !== '05'){
        special = "направлению подготовки"
        profile = "Направленность (профиль) образовательной программы"
      }
      else{
        special = "специальности"
        profile = "Специализация образовательной программы"
      }
      if (prog.main_info.speciality_code.split('.')[1] === '05'){
        basis_profile = "специальности " + prog.main_info.speciality + ", утвержденного приказом Министерства науки и высшего образования Российской Федерации"
      }
      else {
        basis_profile += "направления подготовки " + prog.main_info.speciality + ", утвержденного приказом Министерства науки и высшего образования Российской Федерации"
      }
      if (prog.main_info.creator.title === null){
        prog.main_info.creator.title = ""
      }
      let type = ""
      if (prog.main_info.speciality_code.split('.')[1] === '05'){
        type = "дипломной работы (проекта)"
      }
      else if (prog.main_info.speciality_code.split('.')[1] === '04'){
        type = "магистерской диссертации"
      }
      else{
        type = "бакалаврской работы"
      }
      function buildPreambula() {
        var body = [];
        body.push([{text: ``, style: 'twelveNormal', border: [false, false, false, false]},{text: `а)\tзащиты выпускной квалификационной работы`, style: 'twelveNormal', border: [false, false, false, false]}])
        if (prog.main_info.speciality_code === '40.03.01' || prog.main_info.speciality_code === '41.03.01' || prog.main_info.speciality_code === '41.04.01'){
          body.push([{text: ``, style: 'twelveNormal', border: [false, false, false, false]},{text: `б)\tгосударственного экзамена`, style: 'twelveNormal', border: [false, false, false, false]}])
        }

        return body;
      }
      function buildCompetitionCat() {
        var body = [];
        if (prog.competition.UK.length){
          body.push([{text: ``, style: 'twelveNormal',  border: [false, false, false, false]},{text: `a) Универсальные компетенции и индикаторы их достижения`, style: 'twelveNormal', colSpan: 3, border: [false, false, false, false]},{},{}])
          body.push([{text: `Категория (группа) универсальных компетенций`, style: 'twelveNormal', colSpan: 2, alignment: 'center', border: [true, true, true, true]},{},{text: `Код и наименование универсальной компетенции`, style: 'twelveNormal', alignment: 'center', border: [true, true, true, true]},{text: `Код и наименование индикатора достижения универсальной компетенции`, style: 'twelveNormal', alignment: 'center', border: [true, true, true, true]}])
          prog.competition.UK.forEach(function(comp) {
            body.push([{text: `${comp.info.cat}`, style: 'twelveNormal', colSpan: 2,  alignment: 'justify', border: [true, true, true, true]},{},{text: `${comp.info.code} ${comp.info.desc}`, style: 'twelveNormal',  alignment: 'justify', border: [true, true, true, true]},{text: htmlToText.fromString(comp.text, {
                wordwrap: 10000,
                tags: {
                  'p': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1 } },
                  'pre': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1 } }
                },
              }), style: 'twelveNormal', alignment: 'justify', border: [true, true, true, true]}]);
          });
          body.push([{text: ``, style: 'twelveNormal',  border: [false, false, false, false]},{text: ``, style: 'twelveNormal', colSpan: 3, border: [false, false, false, false]},{},{}])
        }
        else{
          body.push([{text: ``, style: 'twelveNormal',  border: [false, false, false, false]},{text: ``, style: 'twelveNormal', colSpan: 3, border: [false, false, false, false]},{},{}])
        }
        if (prog.competition.OPK_cat.length){
          body.push([{text: ``, style: 'twelveNormal',  border: [false, false, false, false]},{text: `б) Общепрофессиональные компетенции и индикаторы их достижения`, style: 'twelveNormal', colSpan: 3, border: [false, false, false, false]},{},{}])
          body.push([{text: `Категория (группа) общепрофессиональных компетенций`, style: 'twelveNormal', colSpan: 2, alignment: 'center', border: [true, true, true, true]},{},{text: `Код и наименование общепрофессиональной компетенции`, style: 'twelveNormal', alignment: 'center', border: [true, true, true, true]},{text: `Код и наименование индикатора достижения общепрофессиональной компетенции`, style: 'twelveNormal', alignment: 'center', border: [true, true, true, true]}])
          prog.competition.OPK_cat.forEach(function(comp) {
            body.push([{text: `${comp.info.cat}`, style: 'twelveNormal', colSpan: 2,  alignment: 'justify', border: [true, true, true, true]},{},{text: `${comp.info.code} ${comp.info.desc}`, style: 'twelveNormal',  alignment: 'justify', border: [true, true, true, true]},{text: htmlToText.fromString(comp.text, {
                wordwrap: 10000,
                tags: {
                  'p': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1 } },
                  'pre': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1 } }
                },
              }), style: 'twelveNormal', alignment: 'justify', border: [true, true, true, true]}]);
          });
          body.push([{text: ``, style: 'twelveNormal',  border: [false, false, false, false]},{text: ``, style: 'twelveNormal', colSpan: 3, border: [false, false, false, false]},{},{}])
        }
        else{
          body.push([{text: ``, style: 'twelveNormal',  border: [false, false, false, false]},{text: ``, style: 'twelveNormal', colSpan: 3, border: [false, false, false, false]},{},{}])
        }

        return body;
      }
      function buildCompetition() {
        var body = [];
        if (prog.competition.OPK.length){
          body.push([{text: ``, style: 'twelveNormal', alignment: 'justify', border: [false, false, false, false]},{text: `б) Общепрофессиональные компетенции и индикаторы их достижения`, style: 'twelveNormal', colSpan: 2, alignment: 'justify', border: [false, false, false, false]},{}])
          body.push([{text: `Код и наименование общепрофессиональной компетенции`, style: 'twelveNormal', colSpan: 2, alignment: 'justify', border: [true, true, true, true]},{},{text: `Код и наименование индикатора достижения общепрофессиональной компетенции`, style: 'twelveNormal', alignment: 'justify', border: [true, true, true, true]}])
          prog.competition.OPK.forEach(function(comp) {
            body.push([{text: `${comp.name}`, style: 'twelveNormal', colSpan: 2, alignment: 'justify', border: [true, true, true, true]},{}, {text: htmlToText.fromString(comp.text, {
                wordwrap: 10000,
                tags: {
                  'p': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1 } },
                  'pre': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1 } }
                },
              }), style: 'twelveNormal', alignment: 'justify', border: [true, true, true, true]}]);
          });
          body.push([{text: ``, style: 'twelveNormal', colSpan: 3, border: [false, false, false, false]},{},{}])
        }
        else{
          body.push([{text: ``, style: 'twelveNormal', colSpan: 3, border: [false, false, false, false]},{},{}])
        }
        if (prog.competition.PK.length){
          body.push([{text: ``, style: 'twelveNormal', alignment: 'justify', border: [false, false, false, false]},{text: `в) Профессиональные компетенции и индикаторы их достижения`, style: 'twelveNormal', colSpan: 2, alignment: 'justify', border: [false, false, false, false]},{}])
          body.push([{text: `Код и наименование профессиональной компетенции`, style: 'twelveNormal', colSpan: 2, alignment: 'justify', border: [true, true, true, true]},{},{text: `Код и наименование индикатора достижения профессиональной компетенции`, style: 'twelveNormal', alignment: 'justify', border: [true, true, true, true]}])
          prog.competition.PK.forEach(function(comp) {
            body.push([{text: `${comp.name}`, style: 'twelveNormal', colSpan: 2, alignment: 'justify', border: [true, true, true, true]},{}, {text: htmlToText.fromString(comp.text, {
                wordwrap: 10000,
                tags: {
                  'p': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1 } },
                  'pre': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1 } }
                },
              }), style: 'twelveNormal', alignment: 'justify', border: [true, true, true, true]}]);
          });
          body.push([{text: ``, style: 'twelveNormal', colSpan: 3, border: [false, false, false, false]},{},{}])
        }
        else{
          body.push([{text: ``, style: 'twelveNormal', colSpan: 3, border: [false, false, false, false]},{},{}])
        }
        if (prog.competition.DPK.length){
          body.push([{text: ``, style: 'twelveNormal', alignment: 'justify', border: [false, false, false, false]},{text: `г) Дополнительные профессиональные компетенции и индикаторы их достижения`, style: 'twelveNormal', colSpan: 2, alignment: 'justify', border: [false, false, false, false]},{}])
          body.push([{text: `Код и наименование дополнительной профессиональной компетенции`, style: 'twelveNormal', colSpan: 2, alignment: 'justify', border: [true, true, true, true]},{},{text: `Код и наименование индикатора достижения дополнительной профессиональной компетенции`, style: 'twelveNormal', alignment: 'justify', border: [true, true, true, true]}])
          prog.competition.DPK.forEach(function(comp) {
            body.push([{text: `${comp.name}`, style: 'twelveNormal', colSpan: 2, alignment: 'justify', border: [true, true, true, true]},{}, {text: htmlToText.fromString(comp.text, {
                wordwrap: 10000,
                tags: {
                  'p': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1 } },
                  'pre': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1 } }
                },
              }), style: 'twelveNormal', alignment: 'justify', border: [true, true, true, true]}]);
          });
          body.push([{text: ``, style: 'twelveNormal', colSpan: 3, border: [false, false, false, false]},{},{}])
        }
        else{
          body.push([{text: ``, style: 'twelveNormal', colSpan: 3, border: [false, false, false, false]},{},{}])
        }

        return body;
      }

      function buildSoftware() {
        var body = [];
        let n_soft = 0
        if (prog.software.length || prog.resources.length){
          body.push([{text: `№`, style: 'twelveNormal', alignment: 'center', border: [true, true, true, true]},{text: `Наименование`, style: 'twelveNormal', alignment: 'center', border: [true, true, true, true]},{text: `Описание`, style: 'twelveNormal', alignment: 'center', border: [true, true, true, true]}])
          prog.software.forEach(function(soft) {
            n_soft += 1
            body.push([{text: `${n_soft}`, style: 'twelveNormal',  alignment: 'justify', border: [true, true, true, true]},{text: `${soft.info.name}`, style: 'twelveNormal',  alignment: 'justify', border: [true, true, true, true]},{text: `${soft.info.license}`, style: 'twelveNormal', alignment: 'justify', border: [true, true, true, true]}]);
          });
          prog.resources.forEach(function(res) {
            n_soft += 1
            body.push([{text: `${n_soft}`, style: 'twelveNormal',  alignment: 'justify', border: [true, true, true, true]},{text: `${res.name}`, style: 'twelveNormal',  alignment: 'justify', border: [true, true, true, true]},{text: `${res.desc}`, style: 'twelveNormal', alignment: 'justify', border: [true, true, true, true]}]);
          });
        }
        body.push([{text: ``, style: 'twelveNormal', colSpan: 3, alignment: 'center', border: [false, false, false, false]},{},{}])

        return body;
      }
      function buildDataBases() {
        var body = [];
        if (prog.data_bases.length){
          body.push([{text: `№`, style: 'twelveNormal', alignment: 'center', border: [true, true, true, true]},{text: `Наименование`, style: 'twelveNormal', alignment: 'center', border: [true, true, true, true]},{text: `Описание`, style: 'twelveNormal', alignment: 'center', border: [true, true, true, true]}])
          prog.data_bases.forEach(function(db) {
            body.push([{text: `${prog.data_bases.indexOf(db) + 1}`, style: 'twelveNormal',  alignment: 'justify', border: [true, true, true, true]},{text: `${db.name}`, style: 'twelveNormal',  alignment: 'justify', border: [true, true, true, true]},{text: `${db.desc}`, style: 'twelveNormal', alignment: 'justify', border: [true, true, true, true]}]);
          });
        }
        body.push([{text: ``, style: 'twelveNormal', colSpan: 3, alignment: 'center', border: [false, false, false, false]},{},{}])

        return body;
      }

      function buildDiscipline() {
        var body = [];
        prog.discipline.forEach(function(disc) {
          body.push([{text: ``, style: 'twelveNormal', border: [false, false, false, false]},{text: `${disc.name}`, style: 'twelveBold', border: [false, false, false, false]}])
          body.push([{text: htmlToText.fromString(disc.content, {
              wordwrap: 10000,
              tags: {
                'p': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1 } },
                'pre': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1 } }
              },
            }), style: 'twelveNormal', colSpan: 2, border: [false, false, false, false]},{}])
        });
        body.push([{text: ``, style: 'twelveNormal', colSpan: 2, border: [false, false, false, false]},{}])

        return body;
      }
      let titlePage = {
        info: {
          title: `Рабочая программа ${prog.main_info.discipline} ${prog.main_info.speciality} ${prog.main_info.year}`,
          author: 'ЦЦТиТО, АмГУ',
          subject: '',
          keywords: ''
        },
        pageSize: 'A4',
        pageOrientation: 'portrait',
        pageMargins:[60,40,60,60],

        header:[],
        footer:[],
        content: [
          {
            text: 'Министерство науки и высшего образования Российской Федерации \n Федеральное государственное бюджетное образовательное учреждение \n высшего образования \n "Амурский государственный университет"',
            style: "twelveNormal", alignment: 'center',
          },
          {
            style: 'tableExample',
            table: {

              widths: [260,90,70],
              heights: [8,'auto','auto','auto'],
              body: [
                [{text: '', style: 'eightNormal', colSpan: 3, border: [false, false, false, false]}, {},{}],
                [{text: '', style: 'eightNormal', border: [false, false, false, false]}, {text:'УТВЕРЖДАЮ', style: 'twelveNormal', colSpan: 2, lineHeight: 0.7, border: [false, false, false, false]},{}],
                [{text: '', style: 'eightNormal', border: [false, false, false, false]}, {text:'Проректор по учебной и научной работе', colSpan: 2, lineHeight: 0.7, style: 'twelveNormal', border: [false, false, false, false]},{}],
                [{text: '', style: 'eightNormal', border: [false, false, false, false]}, {text:'Лейфа', alignment:'center', style: 'twelveNormal', lineHeight: 0.7, border: [false, false, false, true]},{text:'А.В. Лейфа', style: 'twelveNormal', lineHeight: 0.7, border: [false, false, false, false]}],
                [{text: '', style: 'eightNormal', border: [false, false, false, false]}, {text:`${moment(prog.updated_at).format('LL')}`, colSpan: 2, style: 'twelveNormal', lineHeight: 0.7, border: [false, false, false, true]},{}],
              ]
            }
          },
          {
            style: 'tableExample',
            table: {

              widths: [500],
              heights: [50,'auto','auto','auto',30],
              body: [
                [{text: '', style: 'eightNormal',  border: [false, false, false, false]}],
                [{text: 'ПРОГРАММА', alignment:'center', style: 'twelveNormal', border: [false, false, false, false]}],
                [{text: `государственной итоговой аттестации выпускников по ${special} `, alignment:'center', style: 'twelveNormal', border: [false, false, false, false]}],
                [{text: `${prog.main_info.speciality}`, alignment:'center', style: 'twelveNormal', border: [false, false, false, false]}],
                [{text: '', style: 'eightNormal',  border: [false, false, false, false]}],
                [{text: `${profile} – ${prog.main_info.profile}`, style: 'twelveNormal', border: [false, false, false, false]}],
                [{text: `Квалификация выпускника – ${prog.main_info.quality}`, style: 'twelveNormal', border: [false, false, false, false]}],
                [{text: `Год набора – ${prog.main_info.year}`, style: 'twelveNormal', border: [false, false, false, false]}],
                [{text: `Форма обучения – ${prog.main_info.edu_form}`, style: 'twelveNormal', border: [false, false, false, false]}],
              ]
            }
          },
          {
            style: 'tableExample',
            table: {

              widths: [500],
              heights: [160],
              body: [
                [{text:"", style: 'twelveNormal', border: [false, false, false, false]}],
                [{text: `${prog.main_info.year}`, pageBreak: 'after', alignment:'center', style: 'twelveNormal', border: [false, false, false, false]}],
              ]
            }
          },
          {
            text: `\t\t ${basis_first}`, alignment:'justify', style: 'twelveNormal',
          },
          {
            style: 'tableExample',
            table: {

              widths: [15,160,130,100],
              heights: [20,'auto','auto', 20],
              body: [
                [{text: ``, style: 'twelveNormal', colSpan: 4, alignment:'center', border: [false, false, false, false]},{},{},{}],
                [{text: ``, style: 'twelveNormal', alignment:'center', border: [false, false, false, false]}, {text: `Ответственный разработчик`, style: 'twelveNormal', border: [false, false, false, false]},{text: `${prog.main_info.creator.position} ${getInitial(prog.main_info.creator.fio)}`, style: 'twelveNormal', colSpan: 2, alignment:'center', border: [false, false, false, false]},{}],
                [{text: ``, style: 'twelveNormal', alignment:'center', border: [false, false, false, false]},{text: `${(prog.main_info.creator.fio.trim()).split(" ")[0]}`, style: 'twelveNormal', alignment:'center', border: [false, false, false, true]},{text: ``, style: 'twelveNormal', colSpan: 2, alignment:'center', border: [false, false, false, false]},{},],
                [{text: ``, style: 'twelveNormal', colSpan: 4, alignment:'center', border: [false, false, false, false]},{},{},{}],
              ]
            }
          },
          {
            text: `\t\t Программа обсуждена на заседании кафедры ${department.join(" ")}, ${prog.main_info.approval_date} г., протокол № ${prog.main_info.protocol_num}`, alignment:'justify', style: 'twelveNormal',
          },
          {
            style: 'tableExample',
            table: {

              widths: [5,140,80,100],
              heights: [10],
              body: [
                [{text: ``, style: 'twelveNormal', alignment:'center', border: [false, false, false, false]}, {text: ``, style: 'twelveNormal', colSpan: 3, border: [false, false, false, false]},{},{}],
                [{text: ``, style: 'twelveNormal', alignment:'center', border: [false, false, false, false]},{text: `Заведующий кафедрой`, style: 'twelveNormal', alignment:'center', border: [false, false, false, false]}, {text: `${(prog.main_info.dep_manager.trim()).split(" ")[0]}`, style: 'twelveNormal', alignment:'center', border: [false, false, false, true]}, {text: `${getInitial(prog.main_info.dep_manager)}`, style: 'twelveNormal', border: [false, false, false, false]}],
              ]
            }
          },
          {
            style: 'tableExample',
            table: {

              widths: [100,100,30,100,100,30],
              heights: [100,'auto','auto',10],
              body: [
                [{text: ``, style: 'twelveNormal', alignment:'center', colSpan: 6, border: [false, false, false, false]}, {},{},{},{},{}],
                [{text: `СОГЛАСОВАНО`, style: 'twelveNormal', colSpan: 3, border: [false, false, false, false]},{},{}, {text: `СОГЛАСОВАНО`, style: 'twelveNormal', colSpan: 3, border: [false, false, false, false]},{},{}],
                [{text: `Научная библиотека`, style: 'twelveNormal', colSpan: 3, border: [false, false, false, false]},{},{}, {text: `Центр цифровой трансформации и технического обеспечения`, style: 'twelveNormal', colSpan: 2, border: [false, false, false, false]},{},{text: ``, style: 'twelveNormal', alignment:'center', border: [false, false, false, false]}],
                [{text: `Петрович`, style: 'twelveNormal', alignment:'center', border: [false, false, false, true]},{text: `О.В. Петрович`, style: 'twelveNormal', colSpan: 2, border: [false, false, false, false]},{}, {text: `Тодосейчук`, style: 'twelveNormal', alignment:'center', border: [false, false, false, true]},{text: `А.А. Тодосейчук`, style: 'twelveNormal', colSpan: 2, border: [false, false, false, false]},{}],
                [{text: `${moment(prog.updated_at).format('LL')}`, style: 'twelveNormal', colSpan: 2, alignment:'center', border: [false, false, false, true]},{},{text: ``, style: 'twelveNormal', alignment:'center', border: [false, false, false, false]}, {text: `${moment(prog.updated_at).format('LL')}`, style: 'twelveNormal', colSpan: 2, alignment:'center', border: [false, false, false, true]},{},{text: ``, style: 'twelveNormal', alignment:'center', border: [false, false, false, false]}],
                [{text: ``, style: 'twelveNormal', alignment:'center', colSpan: 6, border: [false, false, false, false]}, {},{},{},{},{}],
                [{text: ``, style: 'twelveNormal', pageBreak: 'after', alignment:'center', colSpan: 6, border: [false, false, false, false]}, {},{},{},{},{}],
              ]
            }
          },
          {
            text: '\t\t 1 Общие положения', style: "twelveBold", alignment: 'justify',
          },
          {
            text: `\t 1.1. ${basis_second}`, style: "twelveNormal", alignment: 'justify',
          },
          {
            style: 'tableExample',
            table: {

              widths: [15,380],
              heights: [20,'auto'],
              body: buildPreambula()
            }
          },
          {
            text: `\t\t 1.2 Виды деятельности выпускников и соответствующие им типы задач професси ональной деятельности:`, style: "twelveNormal", alignment: 'justify',
          },
          {
            text: `\t\t 1.2.1 Виды деятельности выпускников`, style: "twelveNormal", alignment: 'justify',
          },
          {
            text: htmlToText.fromString(prog.active_type.actives, {
              wordwrap: 10000,
              whitespaceCharacters: '\t',
              tags:{
                'p': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1} },
                'pre': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1} }
              },
            }), style: "twelveNormal", alignment: 'justify',
          },
          {
            text: `\t\t 1.2.2 Типы задач профессиональной деятельности `, style: "twelveNormal", alignment: 'justify',
          },
          {
            text: htmlToText.fromString(prog.active_type.tasks, {
              wordwrap: 10000,
              whitespaceCharacters: '\t',
              tags:{
                'p': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1} },
                'pre': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1} }
              },
            }), style: "twelveNormal", alignment: 'justify',
          },
          {
            text: `\t\t 1.2.3. Требования к профессиональной подготовленности выпускника, необходи мые для выполнения им задач профессиональной деятельности`, style: "twelveNormal", alignment: 'justify',
          },
          {
            text: `${prog.preamble_comp}`, style: "twelveNormal", alignment: 'justify',
          },
          {
            style: 'tableExample',
            table: {

              widths: [15,100,130,200],
              heights: [],
              body: buildCompetitionCat()
            }
          },
          {
            style: 'tableExample',
            table: {

              widths: [15,150,290],
              heights: [],
              body: buildCompetition()
            }
          },
          {
            text: '\t\t 2 Требования к выпускной квалификационной работе', style: "twelveBold", alignment: 'justify',
          },
          {
            text: `\t\t 2.1. Вид выпускной квалификационной работы`, style: "twelveNormal", alignment: 'justify',
          },
          {
            text: `Выпускная квалификационная работа выполняется в форме ${type}`, style: "twelveNormal", alignment: 'justify',
          },
          {
            text: `Выпускная квалификационная работа (ВКР) представляет собой самостоятельное законченное исследование, написанное лично выпускником под руководством научного руководителя, свидетельствующее об умении выпускника работать с литературой, обобщать и анализировать фактический материал, используя теоретические знания и практические навыки, полученные при освоении профессиональной образовательной программы`, style: "twelveNormal", alignment: 'justify',
          },
          {
            text: `\t\t 2.2. Структура выпускной квалификационной работы и требования к ее содержа нию`, style: "twelveNormal", alignment: 'justify',
          },
          {
            text: htmlToText.fromString(prog.structure_old, {
              wordwrap: 10000,
              whitespaceCharacters: '\t',
              tags:{
                'p': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1} },
                'pre': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1} }
              },
            }), style: "twelveNormal", alignment: 'justify',
          },
          {
            text: `\t\t 2.3 Примерная тематика и порядок утверждения тем выпускных квалификацион ных работ`, style: "twelveNormal", alignment: 'justify',
          },
          {
            text: htmlToText.fromString(prog.subject_old, {
              wordwrap: 10000,
              whitespaceCharacters: '\t',
              tags:{
                'p': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1} },
                'pre': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1} }
              },
            }), style: "twelveNormal", alignment: 'justify',
          },
          {
            text: '\t\t 2.4 Учебно-методическое и информационное обеспечение', style: "twelveBold", alignment: 'justify',
          },
          {
            text: `\t\t 2.4.1 Рекомендуемая литература`, style: "twelveNormal", alignment: 'justify',
          },
          {
            text: htmlToText.fromString(prog.literature_old, {
              wordwrap: 10000,
              whitespaceCharacters: '\t',
              tags: {
                'a': { options: {
                    hideLinkHrefIfSameAsText: true,
                    noLinkBrackets: true},
                },
                'p': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1 } },
                'pre': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1 } }
              },
            }),
            style: "twelveNormal", alignment: 'justify',
          },
          {
            text: `\t\t 2.4.2 Программное обеспечение и Интернет-ресурсы`, style: "twelveNormal", alignment: 'justify',
          },
          {
            style: 'tableExample',
            table: {

              widths: [15,130,305],
              heights: [],
              body: buildSoftware()
            }
          },
          {
            text: `\t\t 2.4.3 Профессиональные базы данных и информационные справочные системы`, style: "twelveNormal", alignment: 'justify',
          },
          {
            style: 'tableExample',
            table: {

              widths: [15,130,305],
              heights: [],
              body: buildDataBases()
            }
          },
          {
            text: `\t\t 2.5 Порядок выполнения и представления в ГЭК выпускной квалификационной работы`, style: "twelveNormal", alignment: 'justify',
          },
          {
            text: htmlToText.fromString(prog.order_execution_old, {
              wordwrap: 10000,
              whitespaceCharacters: '\t',
              tags:{
                'p': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1} },
                'pre': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1} }
              },
            }), style: "twelveNormal", alignment: 'justify',
          },
          {
            text: `\t\t 2.6 Порядок защиты выпускной квалификационной работы`, style: "twelveNormal", alignment: 'justify',
          },
          {
            text: htmlToText.fromString(prog.order_def_old, {
              wordwrap: 10000,
              whitespaceCharacters: '\t',
              tags:{
                'p': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1} },
                'pre': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1} }
              },
            }), style: "twelveNormal", alignment: 'justify',
          },
          {
            text: `\t\t 2.7 Критерии выставления оценок (соответствия уровня подготовки выпускника требованиям ФГОС ВО) на основе выполнения и защиты им квалификационной работы `, style: "twelveNormal", alignment: 'justify',
          },
          {
            text: htmlToText.fromString(prog.criteria_old, {
              wordwrap: 10000,
              whitespaceCharacters: '\t',
              tags:{
                'p': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1} },
                'pre': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1} }
              },
            }), style: "twelveNormal", alignment: 'justify',
          },
        ],
        styles: {
          eightNormal: {
            fontSize: 8,
            font: 'Times',
            bold: false
          },
          tenNormal: {
            fontSize: 10.5,
            font: 'Times',
            bold: false
          },
          twelveNormal: {
            fontSize: 12,
            font: 'Times',
            bold: false,
            preserveLeadingSpaces: true
          },
          twelveBold: {
            fontSize: 12,
            font: 'Times',
            bold: true,
            preserveLeadingSpaces: true
          },
        }
      };
      if (prog.main_info.speciality_code === '40.03.01' || prog.main_info.speciality_code === '41.03.01' || prog.main_info.speciality_code === '41.04.01') {
        titlePage.content.push(
            {
              text: '\t\t 3 Требования к выпускнику, проверяемые в ходе государственного экзамена', style: "twelveBold", alignment: 'justify',
            },
            {
              text: `\t\t 3.1 Перечень основных учебных модулей – дисциплин образовательной програм- мы или их разделов и вопросов, выносимых для проверки на государственном экзамене`, style: "twelveNormal", alignment: 'justify',
            },
            {
              style: 'tableExample',
              table: {

                widths: [15,440],
                heights: [],
                body: buildDiscipline()
              }
            },
            {
              text: `\t\t 3.2 Список рекомендуемой литературы`, style: "twelveNormal", alignment: 'justify',
            },
            {
              text: htmlToText.fromString(prog.literature_gos_old, {
                wordwrap: 10000,
                whitespaceCharacters: '\t',
                tags:{
                  'p': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1} },
                  'pre': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1} }
                },
              }), style: "twelveNormal", alignment: 'justify',
            },
            {
              text: `\t\t 3.3 Критерии выставления оценок на государственном экзамене`, style: "twelveNormal", alignment: 'justify',
            },
            {
              text: htmlToText.fromString(prog.criteria_gos_old, {
                wordwrap: 10000,
                whitespaceCharacters: '\t',
                tags:{
                  'p': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1} },
                  'pre': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1} }
                },
              }), style: "twelveNormal", alignment: 'justify',
            },
            {
              text: `\t\t 3.4 Порядок проведения экзамена`, style: "twelveNormal", alignment: 'justify',
            },
            {
              text: htmlToText.fromString(prog.order_examination_old, {
                wordwrap: 10000,
                whitespaceCharacters: '\t',
                tags:{
                  'p': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1} },
                  'pre': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1} }
                },
              }), style: "twelveNormal", alignment: 'justify',
            },
        )
      }
      pdfMake.createPdf(titlePage).download(`${prog.main_info.discipline} ${prog.main_info.speciality_code} ${prog.main_info.year}.pdf`);
    },
    MakeSupplementPDF(prog){
      pdfMake.fonts = {
        Times: {
          normal: 'TimesNewRomanCyrRegular.TTF',
          bold: 'TimesNewRomanCyrBold.TTF',
          italics: 'TimesNewRomanCyrItalic.TTF',
          bolditalics: 'TimesNewRomanCyrBoldItalic.TTF'
        }
      }
      moment.locale('ru');
      let special = ""
      let profile = ""
      if (prog.main_info.speciality_code === '38.05.02' || prog.main_info.speciality_code === '37.05.01'){
        special = "специальности"
        profile = "направленность (профиль) программы специалитета"
      }
      else if (prog.main_info.speciality_code === '38.05.01'){
        special = "специальности"
        profile = "специализация программы специалитета"
      }
      else if (prog.main_info.speciality_code.split('.')[1] !== '05'){
        special = "направления подготовки"
        profile = "направленность (профиль) образовательной программы"
      }
      else if (prog.main_info.speciality_code.length === 6 || prog.main_info.speciality_code.length === 7){
        special = ""
        profile = ""
      }
      else{
        special = "специальности"
        profile = "специализация образовательной программы"
      }
      const htmlToText = require('html-to-text');
      function getInitial(fio){
        let initial = ""
        if (fio !== ""){
          fio = fio.replaceAll("  ", " ")
          fio = fio.trim();
          initial += fio.split(' ')[1][0];
          initial +="."
          initial += fio.split(' ')[2][0];
          initial +=". "
          initial += fio.split(' ')[0];
        }
        return initial
      }
      let department = []
      if (prog.main_info.creator.title === null){
        prog.main_info.creator.title = ""
      }
      if (prog.main_info.dep_manager === null){
        prog.main_info.dep_manager = ""
      }

      function buildSoftware() {
        var body = [];
        let n_soft = 0
        if (prog.software.length || prog.resources.length){
          body.push([{text: `№`, style: 'twelveNormal', alignment: 'center', border: [true, true, true, true]},{text: `Наименование`, style: 'twelveNormal', alignment: 'center', border: [true, true, true, true]},{text: `Описание`, style: 'twelveNormal', alignment: 'center', border: [true, true, true, true]}])
          prog.software.forEach(function(soft) {
            n_soft += 1
            body.push([{text: `${n_soft}`, style: 'twelveNormal',  alignment: 'justify', border: [true, true, true, true]},{text: `${soft.info.name}`, style: 'twelveNormal',  alignment: 'justify', border: [true, true, true, true]},{text: `${soft.info.license}`, style: 'twelveNormal', alignment: 'justify', border: [true, true, true, true]}]);
          });
          prog.resources.forEach(function(res) {
            n_soft += 1
            body.push([{text: `${n_soft}`, style: 'twelveNormal',  alignment: 'justify', border: [true, true, true, true]},{text: `${res.name}`, style: 'twelveNormal',  alignment: 'justify', border: [true, true, true, true]},{text: `${res.desc}`, style: 'twelveNormal', alignment: 'justify', border: [true, true, true, true]}]);
          });
        }
        body.push([{text: ``, style: 'twelveNormal', colSpan: 3, alignment: 'center', border: [false, false, false, false]},{},{}])

        return body;
      }
      function buildDataBases() {
        var body = [];
        if (prog.data_bases.length){
          body.push([{text: `№`, style: 'twelveNormal', alignment: 'center', border: [true, true, true, true]},{text: `Наименование`, style: 'twelveNormal', alignment: 'center', border: [true, true, true, true]},{text: `Описание`, style: 'twelveNormal', alignment: 'center', border: [true, true, true, true]}])
          prog.data_bases.forEach(function(db) {
            body.push([{text: `${prog.data_bases.indexOf(db) + 1}`, style: 'twelveNormal',  alignment: 'justify', border: [true, true, true, true]},{text: `${db.name}`, style: 'twelveNormal',  alignment: 'justify', border: [true, true, true, true]},{text: `${db.desc}`, style: 'twelveNormal', alignment: 'justify', border: [true, true, true, true]}]);
          });
        }
        body.push([{text: ``, style: 'twelveNormal', colSpan: 3, alignment: 'center', border: [false, false, false, false]},{},{}])

        return body;
      }
      let titlePage = {
        info: {
          title: `Лист дополнения к программе ГИА ${prog.main_info.discipline} ${prog.main_info.speciality_code} `,
          author: 'ЦЦТиТО, АмГУ',
          subject: '',
          keywords: ''
        },
        pageSize: 'A4',
        pageOrientation: 'portrait',
        pageMargins:[60,40,60,60],

        header:[],
        footer:[],
        content: [
          {
            text: `Лист дополнения к ${prog.name} для ${special} ${prog.main_info.speciality}, ${profile} - ${prog.main_info.profile}`,
            style: "twelveBold", alignment: 'center',
          },
          {
            style: 'tableExample',
            table: {

              widths: [260,90,95],
              heights: ['auto','auto','auto'],
              body: [
                [{text: '', style: 'eightNormal', border: [false, false, false, false]}, {text:'Утверждено на заседании кафедры', style: 'twelveNormal', colSpan: 2, lineHeight: 0.7, border: [false, false, false, false]},{}],
                [{text: '', style: 'eightNormal', border: [false, false, false, false]}, {text:`${prog.main_info.approval_date} г.`, colSpan: 2, style: 'twelveNormal', lineHeight: 0.7, border: [false, false, false, true]},{}],
                [{text: '', style: 'eightNormal', border: [false, false, false, false]}, {text:'Протокол №', style: 'twelveNormal', lineHeight: 0.7, border: [false, false, false, false]},{text:`${prog.main_info.protocol_num}`, style: 'twelveNormal', lineHeight: 0.7, alignment: 'center', border: [false, false, false, true]}],
                [{text: '', style: 'eightNormal', border: [false, false, false, false]}, {text:'Заведующий кафедрой', colSpan: 2, lineHeight: 0.7, style: 'twelveNormal', border: [false, false, false, false]},{}],
                [{text: '', style: 'eightNormal', border: [false, false, false, false]}, {text: `${(prog.main_info.dep_manager.trim()).split(" ")[0]}`, style: 'twelveNormal', alignment:'center', border: [false, false, false, true]}, {text: `${getInitial(prog.main_info.dep_manager)}`, style: 'twelveNormal', border: [false, false, false, false]}],
              ]
            }
          },
          {
            text: '\t\t УЧЕБНО-МЕТОДИЧЕСКОЕ И ИНФОРМАЦИОННОЕ ОБЕСПЕЧЕНИЕ ДИСЦИПЛИНЫ', style: "twelveBold", alignment: 'justify',
          },
          {
            text: `\t\t а) литература`, style: "twelveNormal", alignment: 'justify',
          },
          {
            text: htmlToText.fromString(prog.literature_old, {
              wordwrap: 10000,
              whitespaceCharacters: '\t',
              tags: {
                'a': { options: {
                    hideLinkHrefIfSameAsText: true,
                    noLinkBrackets: true},
                },
                'p': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1 } },
                'pre': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1 } }
              },
            }),
            style: "twelveNormal", alignment: 'justify',
          },
          {
            text: `\t\t б) программное обеспечение и Интернет-ресурсы`, style: "twelveNormal", alignment: 'justify',
          },
          {
            style: 'tableExample',
            table: {

              widths: [15,130,305],
              heights: [],
              body: buildSoftware()
            }
          },
          {
            text: `\t\t в) профессиональные базы данных и информационные справочные системы`, style: "twelveNormal", alignment: 'justify',
          },
          {
            style: 'tableExample',
            table: {

              widths: [15,130,305],
              heights: [],
              body: buildDataBases()
            }
          },
          {
            style: 'tableExample',
            table: {

              widths: [170,90,95],
              heights: [],
              body:[
                [{text:`${prog.main_info.creator.position}`, style: 'twelveNormal', border: [false, false, false, false]},{text: `${(prog.main_info.creator.fio.trim()).split(" ")[0]}`, style: 'twelveNormal', alignment:'center', border: [false, false, false, true]}, {text: `${getInitial(prog.main_info.creator.fio)}`, style: 'twelveNormal', border: [false, false, false, false]}],
              ]
            }
          },
          {
            style: 'tableExample',
            table: {

              widths: [50,90,95],
              heights: [10],
              body:[
                [{text:'', style: 'twelveNormal', colSpan: 3, border: [false, false, false, false]},{},{}],
                [{text:'СОГЛАСОВАНО', style: 'twelveNormal', colSpan: 3, border: [false, false, false, false]},{},{}],
              ]
            }
          },
          {
            style: 'tableExample',
            table: {

              widths: [190,100,120],
              heights: [5,'auto',5,'auto'],
              body:[
                [{text:'', style: 'twelveNormal', colSpan: 3, border: [false, false, false, false]},{},{}],
                [{text:'Директор научной библиотеки', style: 'twelveNormal', border: [false, false, false, false]},{text: `Петрович`, style: 'twelveNormal', alignment:'center', border: [false, false, false, true]}, {text: `О.В. Петрович`, style: 'twelveNormal', border: [false, false, false, false]}],
                [{text:'', style: 'twelveNormal', colSpan: 3, border: [false, false, false, false]},{},{}],
                [{text:'Центр цифровой трансформации и технического обеспечения', style: 'twelveNormal', border: [false, false, false, false]},{text: `Тодосейчук`, style: 'twelveNormal', alignment:'center', border: [false, false, false, true]}, {text: `А.А. Тодосейчук`, style: 'twelveNormal', border: [false, false, false, false]}],
              ]
            }
          },
        ],
        styles: {
          eightNormal: {
            fontSize: 8,
            font: 'Times',
            bold: false
          },
          tenNormal: {
            fontSize: 10.5,
            font: 'Times',
            bold: false
          },
          twelveNormal: {
            fontSize: 12,
            font: 'Times',
            bold: false,
            preserveLeadingSpaces: true
          },
          twelveBold: {
            fontSize: 12,
            font: 'Times',
            bold: true,
            preserveLeadingSpaces: true
          },
        }
      };
      pdfMake.createPdf(titlePage).download(`Лист дополнения к ${prog.main_info.doc_type} ${prog.main_info.speciality} ${prog.main_info.year}.pdf`);
    },
    MakeIAPDF(prog){
      pdfMake.fonts = {
        Times: {
          normal: 'TimesNewRomanCyrRegular.TTF',
          bold: 'TimesNewRomanCyrBold.TTF',
          italics: 'TimesNewRomanCyrItalic.TTF',
          bolditalics: 'TimesNewRomanCyrBoldItalic.TTF'
        }
      }
      moment.locale('ru');
      const htmlToText = require('html-to-text');
      function getInitial(fio){
        let initial = ""
        if (fio !== ""){
          fio = fio.replaceAll("  ", " ")
          fio = fio.trim();
          initial += fio.split(' ')[1][0];
          initial +="."
          initial += fio.split(' ')[2][0];
          initial +=". "
          initial += fio.split(' ')[0];
        }
        return initial
      }
      let department = []
      if (prog.main_info.department !== null){
        department = prog.main_info.department.split(' ').slice(1);
      }
      if (prog.main_info.creator.title === null){
        prog.main_info.creator.title = ""
      }
      if (prog.main_info.dep_manager === null){
        prog.main_info.dep_manager = ""
      }
      let titlePage = {
        info: {
          title: `ПРОГРАММА ИТОГОВОЙ АТТЕСТАЦИИ ${prog.main_info.speciality} `,
          author: 'ЦЦТиТО, АмГУ',
          subject: '',
          keywords: ''
        },
        pageSize: 'A4',
        pageOrientation: 'portrait',
        pageMargins:[60,40,60,60],

        header:[],
        footer:[],
        content: [
          {
            text: 'Министерство науки и высшего образования Российской Федерации \n Федеральное государственное бюджетное образовательное учреждение \n высшего образования \n "Амурский государственный университет"',
            style: "twelveNormal", alignment: 'center',
          },
          {
            style: 'tableExample',
            table: {

              widths: [220,120,110],
              heights: [30,'auto','auto','auto'],
              body: [
                [{text: '', style: 'eightNormal', colSpan: 3, border: [false, false, false, false]}, {},{}],
                [{text: '', style: 'eightNormal', border: [false, false, false, false]}, {text:'УТВЕРЖДАЮ', style: 'twelveNormal', colSpan: 2, lineHeight: 0.7, border: [false, false, false, false]},{}],
                [{text: '', style: 'eightNormal', border: [false, false, false, false]}, {text:'Проректор по учебной и научной работе', colSpan: 2, lineHeight: 0.7, style: 'twelveNormal', border: [false, false, false, false]},{}],
                [{text: '', style: 'eightNormal', border: [false, false, false, false]}, {text:'Лейфа', alignment:'center', style: 'twelveNormal', lineHeight: 0.7, border: [false, false, false, true]},{text:'А.В. Лейфа', style: 'twelveNormal', lineHeight: 0.7, border: [false, false, false, false]}],
                [{text: '', style: 'eightNormal', border: [false, false, false, false]}, {text:`${moment(prog.updated_at).format('LL')}`, colSpan: 2, style: 'twelveNormal', lineHeight: 0.7, border: [false, false, false, true]},{}],
              ]
            }
          },
          {
            style: 'tableExample',
            table: {

              widths: [500],
              heights: [80, 'auto', 'auto', 'auto', 30, 'auto', 'auto', 30, 'auto', 'auto', 120],
              body: [
                [{text: '', style: 'eightNormal', border: [false, false, false, false]}],
                [{text: 'ПРОГРАММА ИТОГОВОЙ АТТЕСТАЦИИ', alignment: 'center', style: 'twelveNormal', border: [false, false, false, false]}],
                [{text: `подготовка научных и научно-педагогических`, alignment: 'center', style: 'twelveNormal', border: [false, false, false, false]}],
                [{text: 'кадров в аспирантуре', alignment: 'center', style: 'twelveNormal', border: [false, false, false, false]}],
                [{text: ``, style: 'twelveNormal', border: [false, false, false, false]}],
                [{text: `Научная специальность`, alignment: 'center', style: 'twelveNormal', border: [false, false, false, false]}],
                [{text: `${prog.main_info.speciality}`, alignment: 'center', style: 'twelveNormal', border: [false, false, false, false]}],
                [{text: ``, style: 'twelveNormal', border: [false, false, false, false]}],
                [{text: `Форма обучения`, alignment: 'center', style: 'twelveNormal', border: [false, false, false, false]}],
                [{text: `${prog.main_info.edu_form}`, alignment: 'center', style: 'twelveNormal', border: [false, false, false, false]}],
                [{text: ``, style: 'twelveNormal', border: [false, false, false, false]}],
                [{text: `Год набора                                                                                                                               ${prog.main_info.year}`, style: 'twelveNormal', border: [false, false, false, false]}],
              ]
            }
          },
          {
            style: 'tableExample',
            table: {

              widths: [500],
              heights: [100],
              body: [
                [{text:"", style: 'twelveNormal', border: [false, false, false, false]}],
                [{text: `${prog.main_info.year}`, pageBreak: 'after', alignment:'center', style: 'twelveNormal', border: [false, false, false, false]}],
              ]
            }
          },
          {
            text: `\t\t ${prog.main_info.basis} от ${prog.main_info.basis_date} № ${prog.main_info.basis_num}`, alignment:'justify', style: 'twelveNormal',
          },
          {
            style: 'tableExample',
            table: {

              widths: [15,160,130,100],
              heights: [20,'auto','auto', 'auto', 20],
              body: [
                [{text: ``, style: 'twelveNormal', colSpan: 4, alignment:'center', border: [false, false, false, false]},{},{},{}],
                [{text: ``, style: 'twelveNormal', alignment:'center', border: [false, false, false, false]}, {text: `Разработчик:`, style: 'twelveNormal', colSpan: 3, border: [false, false, false, false]},{},{}],
                [{text: ``, style: 'twelveNormal', alignment:'center', border: [false, false, false, false]}, {text: `Руководитель ПА по научной специальности:`, style: 'twelveNormal', colSpan: 3, border: [false, false, false, false]},{},{}],
                [{text: ``, style: 'twelveNormal', alignment:'center', border: [false, false, false, false]}, {text: `\t\t\t${(prog.main_info.creator.fio.trim()).split(" ")[0]}                                ${getInitial(prog.main_info.creator.fio)}`, style: 'twelveNormal', colSpan: 3, border: [false, false, false, true]},{},{}],
                [{text: ``, style: 'twelveNormal', colSpan: 4, alignment:'center', border: [false, false, false, false]},{},{},{}],
              ]
            }
          },
          {
            text: `\t\t Программа обсуждена на заседании кафедры ${department.join(" ")}, ${prog.main_info.approval_date} г., протокол № ${prog.main_info.protocol_num}`, alignment:'justify', style: 'twelveNormal',
          },
          {
            style: 'tableExample',
            table: {

              widths: [5,140,80,100],
              heights: [10],
              body: [
                [{text: ``, style: 'twelveNormal', alignment:'center', border: [false, false, false, false]}, {text: ``, style: 'twelveNormal', colSpan: 3, border: [false, false, false, false]},{},{}],
                [{text: ``, style: 'twelveNormal', alignment:'center', border: [false, false, false, false]},{text: `Заведующий кафедрой`, style: 'twelveNormal', alignment:'center', border: [false, false, false, false]}, {text: `${(prog.main_info.dep_manager.trim()).split(" ")[0]}`, style: 'twelveNormal', alignment:'center', border: [false, false, false, true]}, {text: `${getInitial(prog.main_info.dep_manager)}`, style: 'twelveNormal', border: [false, false, false, false]}],
              ]
            }
          },
          {
            style: 'tableExample',
            table: {

              widths: [80,80,30,120,120,30],
              heights: [100,'auto','auto',10],
              body: [
                [{text: ``, style: 'twelveNormal', alignment:'center', colSpan: 6, border: [false, false, false, false]}, {},{},{},{},{}],
                [{text: `СОГЛАСОВАНО`, style: 'twelveNormal', colSpan: 3, border: [false, false, false, false]},{},{}, {text: `СОГЛАСОВАНО`, style: 'twelveNormal', colSpan: 3, border: [false, false, false, false]},{},{}],
                [{text: `Научная библиотека`, style: 'twelveNormal', colSpan: 3, border: [false, false, false, false]},{},{}, {text: `Зав. отделом докторантуры и аспирантуры`, style: 'twelveNormal', colSpan: 2, border: [false, false, false, false]},{},{text: ``, style: 'twelveNormal', alignment:'center', border: [false, false, false, false]}],
                [{text: `Петрович`, style: 'twelveNormal', alignment:'center', border: [false, false, false, true]},{text: `О.В. Петрович`, style: 'twelveNormal', colSpan: 2, border: [false, false, false, false]},{}, {text: `Сизова`, style: 'twelveNormal', alignment:'center', border: [false, false, false, true]},{text: `Е.С. Сизова`, style: 'twelveNormal', colSpan: 2, border: [false, false, false, false]},{}],
                [{text: `${moment(prog.updated_at).format('LL')}`, style: 'twelveNormal', colSpan: 2, alignment:'center', border: [false, false, false, true]},{},{text: ``, style: 'twelveNormal', alignment:'center', border: [false, false, false, false]}, {text: `${moment(prog.updated_at).format('LL')}`, style: 'twelveNormal', colSpan: 2, alignment:'center', border: [false, false, false, true]},{},{text: ``, style: 'twelveNormal', alignment:'center', border: [false, false, false, false]}],
                [{text: ``, style: 'twelveNormal', alignment:'center', colSpan: 6, border: [false, false, false, false]}, {},{},{},{},{}],
                [{text: ``, style: 'twelveNormal', pageBreak: 'after', alignment:'center', colSpan: 6, border: [false, false, false, false]}, {},{},{},{},{}],
              ]
            }
          },
          {
            text: '\t\t 1. Общие положения', style: "twelveBold", alignment: 'justify',
          },
          {
            text: "\t\t1.1 Итоговая аттестация по  программе аспирантуры  по научной специальности " + prog.main_info.speciality + " проводится в форме оценки диссертации на соответствие критериям, установленным Федеральным законом «О науке и государственной научно-технической политике» и «Положением о присуждении ученых степеней», утвержденным Постановлением Правительства Российской Федерации от 24.09.2013 № 842. \n" +
                "\t\tИтоговая аттестация является обязательной.\n" +  "\t\t1.2 К итоговой аттестации допускается аспирант, полностью выполнивший индивидуальный план работы, в том числе подготовивший диссертацию к защите." +
                "\t\tВ случае досрочного выполнения аспирантом обязанностей по освоению программы аспирантуры и выполнению индивидуального плана работы при условии завершения работы над диссертацией и отсутствия академической задолженности по личному заявлению аспиранта, согласованному с его научным руководителем, в порядке, установленном локальным нормативным актом организации, аспиранту предоставляется возможность проведения досрочной итоговой аттестации.\n" + "\t\t1.3 К задачам итоговой аттестации относятся:" +
                "\t\t- оценка диссертации на соответствие критериям, установленным «Положением о присуждении ученых степеней», утвержденным Постановлением Правительства Российской Федерации от 24.09.2013 № 842;\n" +
                "\t\t- оценка уровня сформированных у выпускника необходимых знаний методологических и теоретических основ, современных технологий по соответствующему направлению исследований в рамках научной специальности; методики написания, правил оформления и порядка защиты диссертации; умений планировать и осуществлять научную (научно-исследовательскую) и научно-педагогическую деятельность; владения навыками написания и оформления научных отчетов, докладов, публикаций, диссертации в соответствии с установленными критериями.\n" +
                "\t\tОбщая трудоемкость итоговой аттестации составляет 6 зачетных единиц (216 академических часа).", style: "twelveNormal", alignment: 'justify',
          },
          {
            text: '\t\t 2. Нормативные документы ', style: "twelveBold", alignment: 'justify',
          },
          {
            text: "\t\tНормативно-правовую базу для итоговой аттестации составляют:\n" +
                "\t\tФедеральный закон РФ от 29 декабря 2012 г. № 273-ФЗ «Об образовании в Российской Федерации» (с изменениями и дополнениями); \n" +
                "\t\tФедеральный закон РФ от 23 августа 1996 г. N 127-ФЗ «О науке и государственной научно-технической политике»; \n" +
                "\t\t«Положение о присуждении ученых степеней», утвержденное Постановлением Правительства Российской Федерации от 24.09.2013 № 842 «О порядке присуждения учёных степеней»; \n" +
                "\t\t«Положение о совете по защите диссертаций на соискание ученой степени кандидата наук, на соискание ученой степени доктора наук», утвержденным приказом  Министерства образования и науки Российской Федерации от 10.11.2017 № 1093 (с изменениями и дополнениями от 24.02.2021 и 07.06.2021); \n" +
                "\t\tГОСТ Р 7.0.11-2011. Национальный стандарт Российской Федерации. Система стандартов по информации, библиотечному и издательскому делу. Диссертация и автореферат диссертации. Структура и правила оформления (утв. приказом Федерального агентства по техническому регулированию и метрологии от 13.12.2011 № 811-ст); \n" +
                "\t\tГОСТ 7.32-2017. Межгосударственный стандарт. Система стандартов по информации, библиотечному и издательскому делу. Отчет о научно-исследовательской работе. Структура и правила оформления (введен в действие Приказом Росстандарта от 24.10.2017 № 1494-ст). \n"
            , style: "twelveNormal", alignment: 'justify',
          },
          {
            text: '\t\t 3 Требования к подготовленной диссертации и её представлению', style: "twelveBold", alignment: 'justify',
          },
          {
            text: "\t\t3.1 Подготовленная диссертация должна соответствовать критериям, установленным «Положением о присуждении ученых степеней», утвержденным Постановлением Правительства Российской Федерации от 24.09.2013 № 842:\n" +
                "\t\t- п. 9. Диссертация на соискание ученой степени кандидата наук должна быть научно-квалификационной работой, в которой содержится решение научной задачи, имеющей значение для развития соответствующей отрасли знаний, либо изложены новые научно обоснованные технические, технологические или иные решения и разработки, имеющие существенное значение для развития страны;\n" +
                "\t\t- п. 10. Диссертация должна быть написана автором самостоятельно, обладать внутренним единством, содержать новые научные результаты и положения, выдвигаемые для публичной защиты, и свидетельствовать о личном вкладе автора диссертации в науку. \n" +
                "\t\t3.2 В диссертации, имеющей прикладной характер, должны приводиться сведения о практическом использовании полученных автором диссертации научных результатов, а в диссертации, имеющей теоретический характер, - рекомендации по использованию научных выводов. \n" +
                "\t\t3.3 Предложенные автором диссертации решения должны быть аргументированы, и оценены по сравнению с другими известными решениями; \n" +
                "\t\t- п. 11. Основные научные результаты диссертации должны быть опубликованы в рецензируемых научных изданиях;\n" +
                "\t\t- п. 12. Требования к рецензируемым изданиям и правила формирования их перечня устанавливаются Министерством науки и высшего образования Российской Федерации;\n" +
                "\t\t- п. 13. Количество публикаций, в которых излагаются основные научные результаты диссертации на соискание ученой степени кандидата наук, в рецензируемых изданиях должно быть:\n" +
                "\t\tв области искусствоведения и культурологии, социально-экономических, общественных и гуманитарных наук - не менее 3;\n" +
                "\t\tв остальных областях - не менее 2.\n" +
                "\t\t3.4 К публикациям, в которых излагаются основные научные результаты диссертации на соискание ученой степени, в рецензируемых изданиях приравниваются патенты на изобретения, патенты (свидетельства) на полезную модель, патенты на промышленный образец, патенты на селекционные достижения, свидетельства на программу для электронных вычислительных машин, базу данных, топологию интегральных микросхем, зарегистрированные в установленном порядке;\n" +
                "\t\t- п. 14. В диссертации соискатель ученой степени обязан ссылаться на автора и (или) источник заимствования материалов или отдельных результатов.\n" +
                "\t\tПри использовании в диссертации результатов научных работ, выполненных соискателем ученой степени лично и (или) в соавторстве, соискатель ученой степени обязан отметить в диссертации это обстоятельство.\n" +
                "\t\t3.5 Диссертация и автореферат диссертации оформляются в соответствии с требованиями, устанавливаемыми Министерством науки и высшего образования Российской Федерации. Диссертация и автореферат представляются на русском языке.\n" +
                "\t\t3.6 Общая структура и правила оформления диссертации и автореферата представлены в ГОСТ Р 7.0.11-2011 «Диссертация и автореферат диссертации. Структура и правила оформления»\n" +
                "\t\t3.7 В соответствии  с п. 30 «Положения о совете по защите диссертаций на соискание ученой степени кандидата наук, на соискание ученой степени доктора наук», утвержденным приказом Министерства образования и науки Российской Федерации от 10.11.2017 № 1093 (с изменениями и дополнениями от 24.02.2021 и 07.06.2021) диссертация оформляется в виде рукописи и имеет следующую структуру:\n" +
                "\t\tа) титульный лист;\n" +
                "\t\tб) оглавление;\n" +
                "\t\tв) текст диссертации, включающий в себя:\n" +
                "\t\tвведение;\n" +
                "\t\tосновную часть;\n" +
                "\t\tзаключение;\n" +
                "\t\tсписок литературы;\n" +
                "\t\tсписок научных публикаций, в которых изложены основные научные результаты диссертации).\n" +
                "\t\tТекст диссертации также может включать список сокращений и условных обозначений, словарь терминов, список иллюстративного материала, приложения.\n" +
                "\t\tВведение к диссертации включает в себя актуальность избранной темы, степень ее разработанности, объект и предмет исследования, цели и задачи, научную новизну, теоретическую и практическую значимость работы, методологию и методы диссертационного исследования, положения, выносимые на защиту, степень достоверности и апробацию результатов.\n" +
                "\t\tОсновная часть диссертации состоит из нескольких логически завершенных глав или разделов, которые могут разбиваться на параграфы или подразделы соответственно. Каждая из глав (разделов) посвящена решению одной из задач, сформулированных во введении, и заканчивается выводами, к которым пришел автор в результате проведенных исследований. Количество глав (разделов) определяется логикой диссертационного исследования, и, как правило, не менее четырех. Названия глав (разделов) должны быть краткими и точно отражать их основное содержание.\n" +
                "\t\tВ заключении диссертации излагаются итоги выполненного исследования – конкретные выводы по результатам исследования, в соответствии с поставленными задачами, представляющие собой решение этих задач; основной научный результат, полученный автором в соответствии с целью исследования (решение поставленной научной проблемы, получение/применение нового знания о предмете и объекте); рекомендации, перспективы дальнейшей разработки темы.\n" +
                "\t\t3.8 Объём автореферата - до 1 авторского листа (16 стр. текста: формат А4, шрифт 14 пт, одинарный интервал). Для области гуманитарных наук объём автореферата может составлять до 1,5 авторского листа\n" +
                "\t\tВ автореферате диссертации излагаются основные идеи и выводы диссертации, показывается вклад автора в проведенное исследование, степень новизны и практическая значимость приведенных результатов исследований, приводится список публикаций автора диссертации, в которых отражены основные научные результаты диссертации.\n" +
                "\t\tСтруктура рукописи диссертации должна отражать логику диссертационного исследования и обеспечивать единство и взаимосвязь  его элементов.   Рекомендуемый  объём  диссертации – 100-150 стр. текста: формат А4, шрифт 14 пт, полуторный интервал. \n" +
                "\t\t3.9 Подготовленная диссертация представляется на выпускающую кафедру для оценки диссертации на соответствие критериям, установленных «Положением о присуждении ученых степеней»,    утвержденным    Постановлением  Правительства  Российской Федерации  от 24.09.2013 № 842 «О порядке присуждения учёных степеней» в сроки, предусмотренные индивидуальным планом, вместе с авторефератом диссертации и отзывом научного руководителя. \n" +
                "\t\t3.10 В отзыве научного руководителя дается оценка уровня сформированных у выпускника необходимых знаний методологических и теоретических основ, современных технологий по соответствующему направлению исследований в рамках научной специальности; методики написания, правил оформления и порядка защиты диссертации; умений планировать и осуществлять научную (научно-исследовательскую) и научно-педагогическую деятельность; владения навыками написания и оформления научных отчетов, докладов, публикаций, диссертации в соответствии с установленными критериями.\n" +
                "\t\t3.11 Представление аспирантом доклада по диссертации носит характер научной дискуссии и проходит в обстановке требовательности, принципиальности и соблюдения научной и педагогической этики.\n" +
                "\t\tПредставление и обсуждение доклада проводятся в следующем порядке:\n" +
                "\t\t– информация председателя заседания об аспиранте, теме работы, научном руководителе, рецензентах;\n" +
                "\t\t– выступление аспиранта с докладом (15-20 минут);\n" +
                "\t\t– вопросы, заданные участниками заседания по теме работы, и ответы на них;\n" +
                "\t\t– выступление научного руководителя с краткой характеристикой аспиранта;\n" +
                "\t\t– выступление рецензентов;\n" +
                "\t\t– ответ аспиранта на вопросы рецензентов;\n" +
                "\t\t– дискуссия, в которой может принять участие любой присутствующий на защите;\n" +
                "\t\t– обсуждение и объявление решения о соответствии диссертации критериям.\n" +
                "\t\t3.12 Аспиранту, успешно прошедшему итоговую аттестацию по программе аспирантуры, не позднее 30 календарных дней с даты её проведения выдаётся заключение и свидетельство об окончании аспирантуры.\n" +
                "\t\tВ заключении отражаются личное участие аспиранта в получении результатов, изложенных в диссертации, степень достоверности результатов проведенных аспирантом исследований, их новизна и практическая значимость, ценность научных работ аспиранта, соответствие диссертации требованиям, установленным «Положением о присуждении ученых степеней», утвержденным Постановлением Правительства Российской Федерации от 24.09.2013 № 842, научная специальность (научные специальности) и отрасль науки, которым соответствует диссертация, полнота изложения материалов диссертации в работах, принятых к публикации и (или) опубликованных аспирантом.\n" +
                "\t\tПорядок подготовки заключения  осуществляется в соответствии с локальными нормативными актами университета.\n" +
                "\t\t3.13 Аспирантам, получившим на итоговой аттестации неудовлетворительные результаты, выдается справка об освоении программ аспирантуры по образцу, устанавливаемому университетом, а также заключение, содержащее информацию о несоответствии диссертации критериям, установленным «Положением о присуждении ученых степеней», утвержденным Постановлением Правительства Российской Федерации от 24.09.2013 № 842.\n" +
                "\t\t3.14 В случае несогласия с результатами итоговой аттестации аспирант имеет право на апелляцию. Для этого необходимо лично не позднее следующего рабочего дня после  объявления результатов  итоговой аттестации подать в апелляционную комиссию в письменном виде апелляцию о  нарушении, по его мнению, установленной  процедуры проведения итоговой аттестации и (или) несогласия с результатами итоговой аттестации. \n" +
                "\t\tПри рассмотрении апелляции апелляционная комиссия выносит одно из следующих решений: \n" +
                "\t\t- об отклонении апелляции и сохранении результата итоговой аттестации; \n" +
                "\t\t- об удовлетворении апелляции и выставлении иного результата итоговой аттестации. \n" +
                "\t\tРешение апелляционной комиссии не позднее следующего рабочего дня передаётся председателю заседания. Решение апелляционной комиссии является окончательным и пересмотру не подлежит.\n"
            , style: "twelveNormal", alignment: 'justify',
          },
        ],
        styles: {
          eightNormal: {
            fontSize: 8,
            font: 'Times',
            bold: false
          },
          tenNormal: {
            fontSize: 10.5,
            font: 'Times',
            bold: false
          },
          twelveNormal: {
            fontSize: 12,
            font: 'Times',
            bold: false,
            preserveLeadingSpaces: true
          },
          twelveBold: {
            fontSize: 12,
            font: 'Times',
            bold: true,
            preserveLeadingSpaces: true
          },
        }
      };
      pdfMake.createPdf(titlePage).download(`ПРОГРАММА ИТОГОВОЙ АТТЕСТАЦИИ ${prog.main_info.speciality}.pdf`);
    },
    MakeNIPDF(prog){
      pdfMake.fonts = {
        Times: {
          normal: 'TimesNewRomanCyrRegular.TTF',
          bold: 'TimesNewRomanCyrBold.TTF',
          italics: 'TimesNewRomanCyrItalic.TTF',
          bolditalics: 'TimesNewRomanCyrBoldItalic.TTF'
        }
      }
      moment.locale('ru');
      const htmlToText = require('html-to-text');
      function getInitial(fio){
        let initial = ""
        if (fio !== ""){
          fio = fio.replaceAll("  ", " ")
          fio = fio.trim();
          initial += fio.split(' ')[1][0];
          initial +="."
          initial += fio.split(' ')[2][0];
          initial +=". "
          initial += fio.split(' ')[0];
        }
        return initial
      }
      let department = []
      if (prog.main_info.department !== null){
        department = prog.main_info.department.split(' ').slice(1);
      }
      if (prog.main_info.creator.title === null){
        prog.main_info.creator.title = ""
      }
      if (prog.main_info.dep_manager === null){
        prog.main_info.dep_manager = ""
      }
      function buildSoftware() {
        var body = [];
        let n_soft = 0
        if (prog.software.length || prog.resources.length){
          body.push([{text: `№`, style: 'twelveNormal', alignment: 'center', border: [true, true, true, true]},{text: `Наименование`, style: 'twelveNormal', alignment: 'center', border: [true, true, true, true]},{text: `Описание`, style: 'twelveNormal', alignment: 'center', border: [true, true, true, true]}])
          prog.software.forEach(function(soft) {
            n_soft += 1
            body.push([{text: `${n_soft}`, style: 'twelveNormal',  alignment: 'justify', border: [true, true, true, true]},{text: `${soft.info.name}`, style: 'twelveNormal',  alignment: 'justify', border: [true, true, true, true]},{text: `${soft.info.license}`, style: 'twelveNormal', alignment: 'justify', border: [true, true, true, true]}]);
          });
          prog.resources.forEach(function(res) {
            n_soft += 1
            body.push([{text: `${n_soft}`, style: 'twelveNormal',  alignment: 'justify', border: [true, true, true, true]},{text: `${res.name}`, style: 'twelveNormal',  alignment: 'justify', border: [true, true, true, true]},{text: `${res.desc}`, style: 'twelveNormal', alignment: 'justify', border: [true, true, true, true]}]);
          });
        }
        body.push([{text: ``, style: 'twelveNormal', colSpan: 3, alignment: 'center', border: [false, false, false, false]},{},{}])

        return body;
      }
      function buildDataBases() {
        var body = [];
        if (prog.data_bases.length){
          body.push([{text: `№`, style: 'twelveNormal', alignment: 'center', border: [true, true, true, true]},{text: `Наименование`, style: 'twelveNormal', alignment: 'center', border: [true, true, true, true]},{text: `Описание`, style: 'twelveNormal', alignment: 'center', border: [true, true, true, true]}])
          prog.data_bases.forEach(function(db) {
            body.push([{text: `${prog.data_bases.indexOf(db) + 1}`, style: 'twelveNormal',  alignment: 'justify', border: [true, true, true, true]},{text: `${db.name}`, style: 'twelveNormal',  alignment: 'justify', border: [true, true, true, true]},{text: `${db.desc}`, style: 'twelveNormal', alignment: 'justify', border: [true, true, true, true]}]);
          });
        }
        body.push([{text: ``, style: 'twelveNormal', colSpan: 3, alignment: 'center', border: [false, false, false, false]},{},{}])

        return body;
      }
      function buildStage() {
        var body = [];
        if (prog.discipline.length){
          body.push([{text: `Этапы`, style: 'twelveNormal', alignment: 'center', border: [true, true, true, true]},{text: `Перечень работ по этапам`, style: 'twelveNormal', alignment: 'center', border: [true, true, true, true]},{text: `Курс`, style: 'twelveNormal', alignment: 'center', border: [true, true, true, true]},{text: `Форма`, style: 'twelveNormal', alignment: 'center', border: [true, true, true, true]}])
          prog.discipline.forEach(function(disc) {
            body.push([{text: `${disc.name}`, style: 'twelveNormal', colSpan: 4, alignment: 'left', border: [true, true, true, true]},{},{},{}])
            disc.work.forEach(function(work) {
              body.push([{text: `${work.stage}`, style: 'twelveNormal', alignment: 'justify', border: [true, true, true, true]},{text: htmlToText.fromString(work.content, {
                  wordwrap: 10000,
                  tags: {
                    'p': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1 } },
                    'pre': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1 } }
                  },
                }), style: 'twelveNormal', alignment: 'justify', border: [true, true, true, true]},{text: `${work.course}`, style: 'twelveNormal', alignment: 'center', border: [true, true, true, true]},{text: `${work.control}`, style: 'twelveNormal', alignment: 'center', border: [true, true, true, true]}]);
            });
          });
          body.push([{text: ``, style: 'twelveNormal', colSpan: 4, alignment: 'center', border: [false, false, false, false]},{},{},{}])
        }
        else{
          body.push([{text: ``, style: 'twelveNormal', colSpan: 4, alignment: 'center', border: [false, false, false, false]},{},{},{}])
        }
        return body;
      }
      let titlePage = {
        info: {
          title: `ПРОГРАММА НАУЧНЫХ ИССЛЕДОВАНИЙ ${prog.main_info.speciality} `,
          author: 'ЦЦТиТО, АмГУ',
          subject: '',
          keywords: ''
        },
        pageSize: 'A4',
        pageOrientation: 'portrait',
        pageMargins:[60,40,60,60],

        header:[],
        footer:[],
        content: [
          {
            text: 'Министерство науки и высшего образования Российской Федерации \n Федеральное государственное бюджетное образовательное учреждение \n высшего образования \n "Амурский государственный университет"',
            style: "twelveNormal", alignment: 'center',
          },
          {
            style: 'tableExample',
            table: {

              widths: [220,120,110],
              heights: [30,'auto','auto','auto'],
              body: [
                [{text: '', style: 'eightNormal', colSpan: 3, border: [false, false, false, false]}, {},{}],
                [{text: '', style: 'eightNormal', border: [false, false, false, false]}, {text:'УТВЕРЖДАЮ', style: 'twelveNormal', colSpan: 2, lineHeight: 0.7, border: [false, false, false, false]},{}],
                [{text: '', style: 'eightNormal', border: [false, false, false, false]}, {text:'Проректор по учебной и научной работе', colSpan: 2, lineHeight: 0.7, style: 'twelveNormal', border: [false, false, false, false]},{}],
                [{text: '', style: 'eightNormal', border: [false, false, false, false]}, {text:'Лейфа', alignment:'center', style: 'twelveNormal', lineHeight: 0.7, border: [false, false, false, true]},{text:'А.В. Лейфа', style: 'twelveNormal', lineHeight: 0.7, border: [false, false, false, false]}],
                [{text: '', style: 'eightNormal', border: [false, false, false, false]}, {text:`${moment(prog.updated_at).format('LL')}`, colSpan: 2, style: 'twelveNormal', lineHeight: 0.7, border: [false, false, false, true]},{}],
              ]
            }
          },
          {
            style: 'tableExample',
            table: {

              widths: [500],
              heights: [80, 'auto', 'auto', 'auto', 'auto', 30, 'auto', 'auto', 30, 'auto', 'auto', 120],
              body: [
                [{text: '', style: 'eightNormal', border: [false, false, false, false]}],
                [{text: 'ПРОГРАММА НАУЧНЫХ ИССЛЕДОВАНИЙ', alignment: 'center', style: 'twelveNormal', border: [false, false, false, false]}],
                [{text: `научной (научно-исследовательской деятельности)`, alignment: 'center', style: 'twelveNormal', border: [false, false, false, false]}],
                [{text: `подготовка научных и научно-педагогических`, alignment: 'center', style: 'twelveNormal', border: [false, false, false, false]}],
                [{text: 'кадров в аспирантуре', alignment: 'center', style: 'twelveNormal', border: [false, false, false, false]}],
                [{text: ``, style: 'twelveNormal', border: [false, false, false, false]}],
                [{text: `Научная специальность`, alignment: 'center', style: 'twelveNormal', border: [false, false, false, false]}],
                [{text: `${prog.main_info.speciality}`, alignment: 'center', style: 'twelveNormal', border: [false, false, false, false]}],
                [{text: ``, style: 'twelveNormal', border: [false, false, false, false]}],
                [{text: `Форма обучения`, alignment: 'center', style: 'twelveNormal', border: [false, false, false, false]}],
                [{text: `${prog.main_info.edu_form}`, alignment: 'center', style: 'twelveNormal', border: [false, false, false, false]}],
                [{text: ``, style: 'twelveNormal', border: [false, false, false, false]}],
                [{text: `Год набора                                                                                                                               ${prog.main_info.year}`, style: 'twelveNormal', border: [false, false, false, false]}],
              ]
            }
          },
          {
            style: 'tableExample',
            table: {

              widths: [500],
              heights: [100],
              body: [
                [{text:"", style: 'twelveNormal', border: [false, false, false, false]}],
                [{text: `${prog.main_info.year}`, pageBreak: 'after', alignment:'center', style: 'twelveNormal', border: [false, false, false, false]}],
              ]
            }
          },
          {
            text: `\t\t ${prog.main_info.basis} от ${prog.main_info.basis_date} № ${prog.main_info.basis_num}`, alignment:'justify', style: 'twelveNormal',
          },
          {
            style: 'tableExample',
            table: {

              widths: [15,160,130,100],
              heights: [20,'auto','auto', 'auto', 20],
              body: [
                [{text: ``, style: 'twelveNormal', colSpan: 4, alignment:'center', border: [false, false, false, false]},{},{},{}],
                [{text: ``, style: 'twelveNormal', alignment:'center', border: [false, false, false, false]}, {text: `Разработчик:`, style: 'twelveNormal', colSpan: 3, border: [false, false, false, false]},{},{}],
                [{text: ``, style: 'twelveNormal', alignment:'center', border: [false, false, false, false]}, {text: `Руководитель ПА по научной специальности:`, style: 'twelveNormal', colSpan: 3, border: [false, false, false, false]},{},{}],
                [{text: ``, style: 'twelveNormal', alignment:'center', border: [false, false, false, false]}, {text: `\t\t\t${(prog.main_info.creator.fio.trim()).split(" ")[0]}                                ${getInitial(prog.main_info.creator.fio)}`, style: 'twelveNormal', colSpan: 3, border: [false, false, false, true]},{},{}],
                [{text: ``, style: 'twelveNormal', colSpan: 4, alignment:'center', border: [false, false, false, false]},{},{},{}],
              ]
            }
          },
          {
            text: `\t\t Программа обсуждена на заседании кафедры ${department.join(" ")}, ${prog.main_info.approval_date} г., протокол № ${prog.main_info.protocol_num}`, alignment:'justify', style: 'twelveNormal',
          },
          {
            style: 'tableExample',
            table: {

              widths: [5,140,80,100],
              heights: [10],
              body: [
                [{text: ``, style: 'twelveNormal', alignment:'center', border: [false, false, false, false]}, {text: ``, style: 'twelveNormal', colSpan: 3, border: [false, false, false, false]},{},{}],
                [{text: ``, style: 'twelveNormal', alignment:'center', border: [false, false, false, false]},{text: `Заведующий кафедрой`, style: 'twelveNormal', alignment:'center', border: [false, false, false, false]}, {text: `${(prog.main_info.dep_manager.trim()).split(" ")[0]}`, style: 'twelveNormal', alignment:'center', border: [false, false, false, true]}, {text: `${getInitial(prog.main_info.dep_manager)}`, style: 'twelveNormal', border: [false, false, false, false]}],
              ]
            }
          },
          {
            style: 'tableExample',
            table: {

              widths: [80,80,30,120,120,30],
              heights: [100,'auto','auto',10],
              body: [
                [{text: ``, style: 'twelveNormal', alignment:'center', colSpan: 6, border: [false, false, false, false]}, {},{},{},{},{}],
                [{text: `СОГЛАСОВАНО`, style: 'twelveNormal', colSpan: 3, border: [false, false, false, false]},{},{}, {text: `СОГЛАСОВАНО`, style: 'twelveNormal', colSpan: 3, border: [false, false, false, false]},{},{}],
                [{text: `Научная библиотека`, style: 'twelveNormal', colSpan: 3, border: [false, false, false, false]},{},{}, {text: `Зав. отделом докторантуры и аспирантуры`, style: 'twelveNormal', colSpan: 2, border: [false, false, false, false]},{},{text: ``, style: 'twelveNormal', alignment:'center', border: [false, false, false, false]}],
                [{text: `Петрович`, style: 'twelveNormal', alignment:'center', border: [false, false, false, true]},{text: `О.В. Петрович`, style: 'twelveNormal', colSpan: 2, border: [false, false, false, false]},{}, {text: `Сизова`, style: 'twelveNormal', alignment:'center', border: [false, false, false, true]},{text: `Е.С. Сизова`, style: 'twelveNormal', colSpan: 2, border: [false, false, false, false]},{}],
                [{text: `${moment(prog.updated_at).format('LL')}`, style: 'twelveNormal', colSpan: 2, alignment:'center', border: [false, false, false, true]},{},{text: ``, style: 'twelveNormal', alignment:'center', border: [false, false, false, false]}, {text: `${moment(prog.updated_at).format('LL')}`, style: 'twelveNormal', colSpan: 2, alignment:'center', border: [false, false, false, true]},{},{text: ``, style: 'twelveNormal', alignment:'center', border: [false, false, false, false]}],
                [{text: ``, style: 'twelveNormal', alignment:'center', colSpan: 6, border: [false, false, false, false]}, {},{},{},{},{}],
                [{text: ``, style: 'twelveNormal', pageBreak: 'after', alignment:'center', colSpan: 6, border: [false, false, false, false]}, {},{},{},{},{}],
              ]
            }
          },
          {
            text: '\t\t1. Общие положения', style: "twelveBold", alignment: 'justify',
          },
          {
            text: `${prog.active_type.actives}`, style: "twelveNormal", alignment: 'justify',
          },
          {
            text: '\t\t2. Нормативные документы ', style: "twelveBold", alignment: 'justify',
          },
          {
            text: `${prog.active_type.tasks}`, style: "twelveNormal", alignment: 'justify',
          },
          {
            text: '\t\t3. Объем выполнения научных исследований', style: "twelveBold", alignment: 'justify',
          },
          {
            text: "\t\tНаучные исследования аспиранта – это самостоятельная работа, ориентированная на получение индивидуального научного результата. \n" +
                "\t\tОбъем научных исследований аспиранта определяется учебным планом на весь периода обучения: \n" +
                `\t\tОбщая трудоемкость выполнения научных исследований составляет ${prog.main_info.zet} зачетных единиц, (${prog.main_info.hour} ак.ч.). \n`
            , style: "twelveNormal", alignment: 'justify',
          },
          {
            text: '\t\t4. Этапы выполнения научных исследова', style: "twelveBold", alignment: 'justify',
          },
          {
            style: 'tableExample',
            table: {

              widths: [45,270,50,80],
              heights: [],
              body: buildStage()
            }
          },
          {
            text: '\t\t5. Текущий контроль и промежуточная аттестация по этапам выполнения научного исследования', style: "twelveBold", alignment: 'justify',
          },
          {
            text: `${prog.structure_old}`, style: "twelveNormal", alignment: 'justify',
          },
          {
            text: '\t\t6. Учебно-методическое и информационное обеспечение выполнения плана научной деятельности', style: "twelveBold", alignment: 'justify',
          },
          {
            text: `\t\tРекомендуемая литература`, style: "twelveNormal", alignment: 'justify',
          },
          {
            text: htmlToText.fromString(prog.literature_old, {
              wordwrap: 10000,
              whitespaceCharacters: '\t',
              tags: {
                'a': { options: {
                    hideLinkHrefIfSameAsText: true,
                    noLinkBrackets: true},
                },
                'p': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1 } },
                'pre': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1 } }
              },
            }),
            style: "twelveNormal", alignment: 'justify',
          },
          {
            text: `\t\tПрограммное обеспечение и Интернет-ресурсы`, style: "twelveNormal", alignment: 'justify',
          },
          {
            style: 'tableExample',
            table: {

              widths: [15,130,305],
              heights: [],
              body: buildSoftware()
            }
          },
          {
            text: `\t\tПрофессиональные базы данных и информационные справочные системы`, style: "twelveNormal", alignment: 'justify',
          },
          {
            style: 'tableExample',
            table: {

              widths: [15,130,305],
              heights: [],
              body: buildDataBases()
            }
          },
          {
            text: '\t\t7. Материально-техническое обеспечение выполнения плана научной деятельности', style: "twelveBold", alignment: 'justify',
          },
          {
            text: htmlToText.fromString(prog.subject_old, {
              wordwrap: 10000,
              whitespaceCharacters: '\t',
              tags:{
                'p': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1} },
                'pre': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1} }
              },
            }), style: "twelveNormal", alignment: 'justify',
          },
        ],
        styles: {
          eightNormal: {
            fontSize: 8,
            font: 'Times',
            bold: false
          },
          tenNormal: {
            fontSize: 10.5,
            font: 'Times',
            bold: false
          },
          twelveNormal: {
            fontSize: 12,
            font: 'Times',
            bold: false,
            preserveLeadingSpaces: true
          },
          twelveBold: {
            fontSize: 12,
            font: 'Times',
            bold: true,
            preserveLeadingSpaces: true
          },
        }
      };
      pdfMake.createPdf(titlePage).download(`ПРОГРАММА НАУЧНЫХ ИССЛЕДОВАНИЙ ${prog.main_info.speciality}.pdf`);
    },
  },
  mounted() {
    this.getRPGs(this.year)
  }
}
</script>

<style scoped>

</style>